<template>
<div class="scrolling-box">  

<a id="top"></a>

<b-container class="paddingRL">
  
    <!--
    RunningVids: {{runningVideos.length}}
    RunningOnly:{{isRunningOnly}}
    RunningVids:{{runningVideos[0]}}
    VideosLength:{{videos.length}}    
    Show Hidden Vids: {{seeHidden}}
    Collections: {{collections.length}}
    ClientCollect:{{clientCollections.length}}
    clientCollections[0]: {{clientCollections[0]}}
    NbHidden: {{nbHidden}}

    <b-button @click="updateRunningVids()">Inter</b-button>
    InterVidRun: {{interVidRun}}
    -->

    <!--Filter panel -->  
  <b-form @submit.prevent="onSearchBar" class="borderRL" style="border-bottom:solid 1px #2a5d77">

    <!--Search bar line-->
    <b-input-group size="sm" :disabled='barOrCheck' >
      <b-input-group-prepend><b-button type="submit" style="border-bottom-left-radius:0px" class="input-group-text" variant="db-sb"><b-icon icon="search"></b-icon></b-button></b-input-group-prepend>
      <b-form-input :disabled='barOrCheck' :placeholder="$ml.get('keyfilter')" v-model="search" @input="startTimeoutSearch"></b-form-input>
      <b-input-group-append>
        <b-input-group-text id="popover-help" class="pointerC"> 
          <font-awesome-icon icon="question-circle"></font-awesome-icon> 
        </b-input-group-text>
        <b-button variant="db-sbsq" title="Show advanced filters: Collections" v-if="!showFilterC" @click="showFilterC = !showFilterC; saveShowCol()">
          <b-iconstack>
            <b-icon stacked icon="collection" scale="1.25"/>
            <b-icon stacked icon="plus" scale="0.75" shift-v="-2"/>
            <b-icon stacked :title="selectedCollections.length+' selected collection(s) and '+exludedCollections.length+' excluded collection(s)'" v-if="selectedCollections.length !== 0 && exludedCollections.length !== 0" icon="circle-fill" style="color: #f98e35;" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked :title="selectedCollections.length+' selected collection(s)'" v-else-if="selectedCollections.length !== 0" icon="circle-fill" class="green" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked :title="exludedCollections.length+' excluded collection(s)'" v-else-if="exludedCollections.length !== 0" icon="circle-fill" class="red" shift-v="5" shift-h="10" scale="0.5" /> 
          </b-iconstack>
        </b-button>
        <b-button variant="greenwsq" title="Hide advanced filters: Collections" v-if="showFilterC" @click="showFilterC = !showFilterC; saveShowCol()">
          <b-iconstack>
            <b-icon stacked icon="collection" scale="1.25"/>
            <b-icon stacked icon="dash" scale="0.75" shift-v="-2"/>
            <b-icon stacked :title="selectedCollections.length+' selected collection(s) and '+exludedCollections.length+' excluded collection(s)'" v-if="selectedCollections.length !== 0 && exludedCollections.length !== 0" icon="circle-fill" style="color: #f98e35;" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked :title="selectedCollections.length+' selected collection(s)'" v-else-if="selectedCollections.length !== 0" icon="circle-fill" class="green" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked :title="exludedCollections.length+' excluded collection(s)'" v-else-if="exludedCollections.length !== 0" icon="circle-fill" class="red" shift-v="5" shift-h="10" scale="0.5" /> 
          </b-iconstack>
        </b-button>
        <b-button variant="db-sbsq" title="Show advanced filters: Types" v-if="!showFilterT" style="border-left-color:white !important; border-right:none !important; border-top-right-radius: 0.25rem !important" @click="showFilterT = !showFilterT; saveShowFil()">
          <b-iconstack>
            <b-icon stacked icon="layers-half" scale="1.25" />
            <b-icon stacked icon="plus" scale="0.75" shift-v="3"/>
            <b-icon stacked title="Filter applied on Video Types" v-if="!defaultAdvancedFilters" icon="circle-fill" class="blueV" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked title="Filter applied on Video Qualities" v-else-if="!defaultQFilters" icon="circle-fill" class="blueQ" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked title="Filter applied on [Config]" v-else-if="selectedKey" icon="circle-fill" class="blueC" shift-v="5" shift-h="10" scale="0.5" />
            <b-icon stacked title="Active vids (during last 5min) ONLY selected" v-else-if="isRunningOnly" icon="circle-fill" class="red" shift-v="5" shift-h="10" scale="0.5" />
            <b-icon stacked title="Hidden vids not shown" v-else-if="seeHidden && totalNumberVideoHidden > 0" icon="circle-fill" class="hidden" shift-v="5" shift-h="10" scale="0.5" />
          </b-iconstack>
        </b-button>
        <b-button variant="greenwsq" title="Hide advanced filters: Types" v-if="showFilterT" style="border-right:none !important; border-top-right-radius: 0.25rem !important" @click="showFilterT = !showFilterT; saveShowFil()">
          <b-iconstack>
            <b-icon stacked icon="layers-half" scale="1.25" />
            <b-icon stacked icon="dash" scale="0.75" shift-v="3"/>
            <b-icon stacked title="Filter applied on Video Types" v-if="!defaultAdvancedFilters" icon="circle-fill" class="blueV" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked title="Filter applied on Video Qualities" v-else-if="!defaultQFilters" icon="circle-fill" class="blueQ" shift-v="5" shift-h="10" scale="0.5" /> 
            <b-icon stacked title="Filter applied on [Config]" v-else-if="selectedKey" icon="circle-fill" class="blueC" shift-v="5" shift-h="10" scale="0.5" />
            <b-icon stacked title="Active vids (during last 5min) ONLY selected" v-else-if="isRunningOnly" icon="circle-fill" class="red" shift-v="5" shift-h="10" scale="0.5" />
            <b-icon stacked title="Hidden vids not shown" v-else-if="seeHidden && totalNumberVideoHidden > 0" icon="circle-fill" class="hidden" shift-v="5" shift-h="10" scale="0.5" />
          </b-iconstack>
        </b-button>            
      </b-input-group-append>

      <b-popover
      target="popover-help"
      title="Help with searchbar"
      triggers="click"
      placement="bottomleft"
      >
        {{$ml.get('pluginvideop1')}}<br/>
        {{$ml.get('pluginvideop2')}}<br/>
        {{$ml.get('pluginvideop3')}}<br/>
        {{$ml.get('pluginvideop4')}} 
      </b-popover>
    </b-input-group>

    <!--Collections panel (transition)-->
    <transition name="showFilterC">

      <!-- If Collections panel open -->
      <div v-if="clientCollections && showFilterC" class="panelCT" >

        <!-- Collections title and Search bar among Collections + selected/excluded icons&numbers -->
        <b-row class="align-items-center justify-content-center mb-3">
          <b-col cols="0 col-lg-2"></b-col>
          <b-col cols="6 col-lg-8 p-0" style="text-align: center">
            <b-row class="justify-content-center">
              <span class="h5 pointerEltSB" @click="showFilterC = !showFilterC; saveShowCol()" title="Close Collections Filters Tab">
                <b-iconstack >
                  <b-icon stacked icon="collection" />
                  <b-icon stacked icon="dash" scale="0.5" shift-v="-2"/>
                </b-iconstack>
                Collections
                <b-badge variant="dark">{{clientCollections.length}}</b-badge>
              </span>
              <b-form-group>
                <span class="green circleCT" :title="selectedCollections.length+' selected collection(s)'" v-if="selectedCollections.length !== 0">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon><small>&nbsp;{{selectedCollections.length}}</small>
                </span>
                <span class="red circleCT" :title="exludedCollections.length+' excluded collection(s)'" v-if="exludedCollections.length !== 0">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon><small>&nbsp;{{exludedCollections.length}}</small>
                </span>
              </b-form-group>
            </b-row>
          </b-col>
          <b-col cols="6 col-lg-2 p-0" style="text-align:right">
            <b-button size="sm" variant="mswarning" style="padding:6px 10px; font-size:12px; width:150px" @click="selectedCollections=[];exludedCollections=[];startTimeoutSearch()">
              <b-icon icon="arrow-clockwise" />
              &nbsp;<span v-text="$ml.get('resetCollections')"></span>
            </b-button>
          </b-col>
        </b-row>

        <!-- Buttons of actions on Collections -->
        <b-row class="justify-content-center align-items-center mb-2">
          <b-button size="sm" variant="msstreamblue" style="padding:6px 10px; font-size:12px; margin:5px; width:210px" @click="showModal('newcollection')">
            <b-icon icon="plus-square" />
            &nbsp;<span v-text="$ml.get('addnewcollection')"></span>
          </b-button>
          <b-button size="sm" title="See analytics for ALL videos from selected collections (union)" :disabled="selectedCollections.length < 2" variant="darkblue" style="padding:6px 10px; font-size:12px; margin:5px; width:210px" @click="$router.push('/analytics?collection=' + JSON.stringify(selectedCollections) +'&title=collection&searchtype=union')">
            <b-icon icon="graph-up" />
            &nbsp;<span v-text="$ml.get('showanalyticsunion')"></span> - {{selectedCollections.length}}
          </b-button>
          <b-button size="sm" title="See analytics for videos ONLY present in ALL selected collections (intersection)" :disabled="selectedCollections.length < 2" variant="darkblue" style="padding:6px 10px; font-size:12px; margin:5px; width:210px" @click="$router.push('/analytics?collection=' + JSON.stringify(selectedCollections) +'&title=collection&searchtype=intersection')">
            <b-icon icon="graph-up" />
            &nbsp;<span v-text="$ml.get('showanalyticsinter')"></span> - {{selectedCollections.length}}
          </b-button>
          <b-button size="sm" :disabled="selectedCollections.length < 2" variant="msstreamred" style="padding:6px 10px; font-size:12px; margin:5px; width:210px" @click="showModal('removemultipleglobalcollection')">
            <b-icon icon="trash2" />
            &nbsp;<span v-text="$ml.get('deleteselectedcollection')"></span> - {{selectedCollections.length}}
          </b-button>
          <b-form-input size="sm" style="margin:5px; padding:6px 10px; width:250px" :placeholder="$ml.get('searchColl')" v-model="searchCollection" @input="startFilterCollection"></b-form-input>
        </b-row>
      
        <!-- Separator between Buttons of actions on Collections and List of Collections -->
        <div v-if="clientCollections.length !== 0" style="margin: 5px; border-top: 1px dashed #2F90B0"></div>

        <!-- List of Collections -->
        <b-row style="text-align: center; font-size: small" class="justify-content-center mt-1 mb-1">

          <!-- For each Collection: loop -->
          <div style="font-size:12px; display: inline-block; margin: 0.5rem" v-for="(collection, index) in clientCollections" :key="index">

            <!-- A Collection set as Neutral -->
            <div @click="changeCollectionState(collection)" v-if="selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1" class="tag-not-selected" :title="collection+': all videos from this collection are displayed'">
              <b-icon icon="collection" style="margin-right: 2px" />
              {{collection}}
            </div>

            <!-- A Collection set as Selected -->
            <div @click="changeCollectionState(collection)" v-if="selectedCollections.indexOf(collection) != -1 && exludedCollections.indexOf(collection) === -1" class="tag-selected" :title="collection+': only videos INCLUDED in this collection are displayed'">
              <b-iconstack style="margin-right: 2px">
                <b-icon stacked icon="collection" />
                <b-icon stacked icon="check2" shift-h="2" shift-v="-1" scale="0.9" />
              </b-iconstack>
              {{collection}}
            </div>

            <!-- A Collection set as Excluded -->
            <div @click="changeCollectionState(collection)" v-if="exludedCollections.indexOf(collection) != -1 && selectedCollections.indexOf(collection) === -1" class="tag-excluded" :title="collection+': only videos EXCLUDED from this collection are displayed'">
              <b-iconstack style="margin-right: 2px">
                <b-icon stacked icon="collection" />
                <b-icon stacked icon="x" shift-v="-1" scale="0.9" />
              </b-iconstack>
              {{collection}}
            </div>
            
            <!-- The three actions that can be done on a Collection: Set Rules, Show Analytics, Delete --> 
            <b-icon icon="sliders" class="rounded iconStyle mb-1" font-scale="1.1" @click="collectionAuth = collections.find(x=>x.name === collection); showModal('authorizationsCollection')" title="Edit P2P rules of the collection" />
            <b-icon icon="graph-up" class="rounded iconStyle mb-1" font-scale="1.1" @click="$router.push('/analytics?collection=' + collection +'&title=collection' )" title="Show analytics for the collection" /> 
            <b-icon icon="x" class="rounded-circle iconStyleR mb-1" font-scale="1.1" @click="selectedCollection = collections.find(x=>x.name === collection); showModal('removeglobalcollection')" title="Delete collection" />

          </div> <!-- End of loop on each Collection -->
        </b-row> <!-- End of list of Collections -->

      </div> <!-- End of Collections Panel -->
    </transition>

    <!--Types panel (transition)-->
    <transition name="showFilterT">

      <!--If Types panel open-->
      <div v-if="showFilterT" class="panelCT" >
      
        <!-- Types title and badges list of modifications-->
        <b-row class="align-items-center justify-content-center mb-3">
          <b-col cols="0 col-lg-2"></b-col>
          <b-col cols="6 col-lg-8 p-0" style="text-align: center">
            <b-row class="justify-content-center">
              <span class="pointerEltSB h5" @click="showFilterT = !showFilterT; saveShowFil()" title="Close Types Filters Tab">
                <b-iconstack>
                  <b-icon stacked icon="layers-half" />
                  <b-icon stacked icon="dash" scale="0.5" shift-v="2"/>
                </b-iconstack>
                Types 
              </span>
              <b-form-group>
                <span class="blueV circleCT" title="Filter applied on Video Types" v-if="!defaultAdvancedFilters">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon>
                </span>
                <span class="blueQ circleCT" title="Filter applied on Video Qualities" v-if="!defaultQFilters">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon>
                </span>
                <span class="blueC circleCT" title="Filter applied on [Config]" v-if="selectedKey">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon>
                </span>
                <span class="red circleCT" title="ONLY active vids (in the last 5min) are displayed" v-if="isRunningOnly">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon>
                </span>
                <span class="hidden circleCT" title="Hidden vids are displayed" v-if="seeHidden && totalNumberVideoHidden > 0">
                  <b-icon icon="circle-fill" scale="0.65" ></b-icon>
                </span>
              </b-form-group>
            </b-row>
          </b-col>
          <b-col cols="6 col-lg-2 p-0" style="text-align:right">
            <b-button size="sm" variant="mswarning" style="padding:6px 10px; font-size:12px; width:150px" @click="resetTypesF">
              <b-icon icon="arrow-clockwise" />
              {{$ml.get('resetTypes')}}
            </b-button>
          </b-col>

          <!--
          <b-badge class="pb-1 ml-3 mb-1" @click="isRunningOnly = !isRunningOnly" :title="runningVideos.length+' running video(s) (in the last 5min) in total.'+' Only those videos are displayed.'+' Warning: filters are not considered for this number.'" v-if="isRunningOnly" style="cursor:pointer; border:solid 1px #ba0000" variant="danger">{{runningVideos.length}}</b-badge>
          <b-badge class="pb-1 ml-3 mb-1" @click="isRunningOnly = !isRunningOnly" :title="runningVideos.length+' running video(s) (in the last 5min) in total.'+' All videos are displayed.'+' Warning: filters are not considered for this number.'" v-else style="cursor:pointer; border:solid 1px #ba0000" variant="light">{{runningVideos.length}}</b-badge>
          <b-badge class="pb-1 ml-2 mb-1" @click="seeHidden = !seeHidden" v-if="seeHidden" variant="light" title="Hidden videos are displayed" style="cursor:pointer; border:solid 1px #ba0000">
            <b-icon class="red" icon="play-fill" scale="1.50"></b-icon>
            <b-icon scale="1.20" icon="eye-fill"></b-icon>
          </b-badge>
          <b-badge class="pb-1 ml-2 mb-1" @click="seeHidden = !seeHidden" v-else variant="light" title="Hidden videos are not displayed" style="cursor:pointer; border:solid 1px black">
            <b-icon icon="play" scale="1.50"></b-icon>
            <b-icon icon="eye-slash-fill" scale="1.20"></b-icon>
          </b-badge>
          <b-badge class="pb-1 ml-3 mb-1" variant="primary" v-if="nbrVideoSelected > 0" style="border:solid 1px black">{{nbrVideoSelected}}</b-badge>
          <b-button class="mb-1 ml-1" size="sm" v-if="nbrVideoSelected > 0" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateHideVideo()" title="Hide selected videos">
            <small><font-awesome-layers>
              <font-awesome-icon :icon="['fa', 'eye-slash']" />
            </font-awesome-layers></small>
          </b-button>
          <b-button class="mb-1" size="sm" v-if="nbrVideoSelected > 0" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateUnhideVideo()" title="Unhide selected videos">
            <small><font-awesome-layers>
              <font-awesome-icon :icon="['fa', 'eye']" />
            </font-awesome-layers></small>
          </b-button>
          -->
        </b-row> <!-- End of Types title -->

        <!-- Row for the 2 sub-divided sections of Types -->
        <b-row class="mb-2">

          <!-- Left part on Types, Qualities and Configs -->
          <b-col cols="12 col-sm-12 col-lg-6 p-0" class="borderR">

            <!-- Types filter -->
            <b-row class="m-2">
              <b-col cols="12 col-sm-12 col-lg-4" class="p-0 mb-1">
                <b-icon class="blueV mr-2" title="Filter applied on Video Stream Types" v-if="!defaultAdvancedFilters" icon="circle-fill" scale="0.65" ></b-icon>
                <small>{{$ml.get('filterVT')}}</small>
              </b-col>
              <b-col cols="auto" class="p-0 ml-1">
                <b-form-checkbox-group
                  size="sm"
                  v-model="advancedFilters"
                  :options="advancedFilterOptions"
                  @input="startTimeoutSearch"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>

            <b-row class="m-2">
              <b-col cols="12 col-sm-12 col-lg-4" class="p-0 mb-1">
                <b-icon class="blueV mr-2" title="Filter applied on Protocol Types" v-if="!defaultProtFilters" icon="circle-fill" scale="0.65" ></b-icon>
                <small>{{$ml.get('filterProt')}}</small>
              </b-col>
              <b-col cols="auto" class="p-0 ml-1">
                <b-form-checkbox-group
                  size="sm"
                  v-model="protFilters"
                  :options="advancedProtOptions"
                  @input="startTimeoutSearch"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>

            <b-row class="m-2">
              <b-col cols="12 col-sm-12 col-lg-4" class="p-0 mb-1">
                <b-icon class="blueV mr-2" title="Filter applied on Segments Extensions" v-if="!defaultSegFilters" icon="circle-fill" scale="0.65" ></b-icon>
                <small>{{$ml.get('filterSeg')}}</small>
              </b-col>
              <b-col cols="auto" class="p-0 ml-1">
                <b-form-checkbox-group
                  size="sm"
                  v-model="segFilters"
                  :options="advancedSegOptions"
                  @input="startTimeoutSearch"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>

            <!-- Qualities filter -->
            <b-row class="m-2">
              <b-col cols="12 col-sm-12 col-lg-4" class="p-0 mb-1">
                <b-icon class="blueQ mr-2" title="Filter applied on Video Qualities" v-if="!defaultQFilters" icon="circle-fill" scale="0.65" ></b-icon>
                <small>{{$ml.get('filterVQ')}}</small>
              </b-col>
              <b-col cols="auto" class="p-0 ml-1">
                <b-form-checkbox-group
                  size="sm"
                  v-model="qualityFilters"
                  :options="qualityFilterOptions"
                  @input="startTimeoutSearch"
                ></b-form-checkbox-group>
              </b-col>
            </b-row>

            <!-- Configs filter -->
            <b-row class="m-2 align-items-center" >
              <b-col cols="7 col-sm-7 col-lg-4" class="p-0 mb-1">
                <b-icon class="blueC mr-2" title="Filter applied on [Config]" v-if="selectedKey" icon="circle-fill" scale="0.65" ></b-icon>
                <small style="margin-right: 2rem">
                  {{$ml.get('filterConf')}}
                  [<b-icon icon="gear-fill" /> Configs]:
                </small>
              </b-col>
              <b-col cols="5 col-sm-5 col-lg-8" class="p-0">
                <b-select size="sm" class="w-80" v-model="selectedKey" :options="configurationsOptions" @input="isGetInProgress = true; onSearchBar()"></b-select>
              </b-col>
            </b-row>

          </b-col> <!-- End of left part of Types panel -->

          <!-- Right part of Types panel -->
          <b-col cols="12 col-sm-12 col-lg-6 m-0 p-0">

            <!-- Show only active last 5min -->
            <b-row class="ml-2 mt-0 mb-2 align-items-center small" >
              <b-form-checkbox v-model="isRunningOnly" @input="saveShowActive()"> 
                <p class="pointerC mb-0">
                  {{$ml.get('showactiveonly')}}
                  <small style="margin-left: -2px; font-size:10px">{{$ml.get('last5')}}</small>
                  <b-icon icon="eye-fill" class="red ml-1"/>
                  <b-badge class="runningVidsBadgeWO" style="margin-left:5px;" :title="runningVideos.length+' active vids (in the last 5min) in total. Warning: if any filtering is applied, it is not considered for this number'" v-if="isRunningOnly" >{{formatNbr(runningVideos.length)}}</b-badge>
                  <b-badge class="runningVidsBadgeDisWO" style="margin-left:5px;" :title="runningVideos.length+' active vids (in the last 5min) in total. Warning: if any filtering is applied, it is not considered for this number'" v-else >{{formatNbr(runningVideos.length)}}</b-badge>
                </p>
              </b-form-checkbox>
              <b-icon id="popover-help3" class="pointerC ml-1 mb-2" icon="exclamation-circle" />
              <b-popover
                target="popover-help3"
                triggers="click"
                placement="bottomright"
                >
                {{$ml.get('helpshowrun')}} 
              </b-popover>
              <span class="red pb-2 mt-2 ml-2" title="ONLY active vids (in the last 5min) are displayed" v-if="isRunningOnly">
                <b-icon icon="circle-fill" scale="0.65" ></b-icon>
              </span>

            </b-row>

            <!-- Hidden vids filter -->
            <b-row class="ml-2 mt-0 mb-2 align-items-center small" >
              <b-form-checkbox :disabled="totalNumberVideoHidden === 0" v-model="seeHidden" @input="refreshManual">
                <p class="pointerC mb-0">
                  {{$ml.get('showhidden')}}
                  <b-icon icon="eye-fill"/>
                  <b-badge class="hiddenAuthBadgeDisWO" style="margin-left:10px" :title="totalNumberVideoHidden+' hidden video(s) in total. Warning: if any filtering is applied, it is not considered for this number'" v-if="!seeHidden" >{{formatNbr(totalNumberVideoHidden)}}</b-badge>
                  <b-badge class="hiddenAuthBadgeWO" style="margin-left:10px" :title="totalNumberVideoHidden+' hidden video(s) in total. Warning: if any filtering is applied, it is not considered for this number'" v-else >{{formatNbr(totalNumberVideoHidden)}}</b-badge>
                </p>
              </b-form-checkbox>
              <b-icon id="popover-helphid" class="pointerC ml-1 mb-2" icon="exclamation-circle" />
              <b-popover
                target="popover-helphid"
                triggers="click"
                placement="bottomright"
                >
                {{$ml.get('helphidnbr')}} 
              </b-popover>

              <span class="hidden pb-2 mt-1 ml-2" v-if="seeHidden && totalNumberVideoHidden > 0">
                <b-icon icon="circle-fill" scale="0.65" ></b-icon>
              </span>
            </b-row>

            <!-- Selected vids, hide, unhide -->
            <b-row class="ml-2 mt-0 mb-0 align-items-center small" >
              <span style="margin-top:5px; margin-bottom:5px">
              {{$ml.get('selected')}} 
              <b-badge variant="primary" style="border:solid 1px black; margin-left:5px; margin-right:5px">{{nbrVideoSelected}}</b-badge>
            </span>
              <span v-if="nbrVideoSelected > 0" class="hiddenAuthBadgeDis" style="width:auto !important" @click="updateHideVideo()" title="Hide selected videos">
                {{$ml.get('hide')}}
                <b-icon icon="eye-slash-fill" />
              </span>
              <span v-if="nbrVideoSelected > 0" class="hiddenAuthBadge" style="width:auto !important" @click="updateUnhideVideo()" title="Unhide selected videos">            
                {{$ml.get('unhide')}}
                <b-icon icon="eye-fill" />
              </span>
            </b-row>

          </b-col> <!-- End of Types right panel -->
        </b-row> <!-- End of Types panel 2 sub-divided sections -->

      </div> <!-- End of Types panel -->
    </transition>

    <!--Display part-->
    <b-row class="align-items-center m-3 h6">

      <!--Filters ON: -->
      <b-col cols="12 col-sm-12 col-lg-1 p-0" >
        <b-row class="justify-content-between align-items-center">
          <span>
            {{$ml.get('filter')}}
          </span>
          <span>
            <b-button size="sm" variant="mswarning" style="padding:2px 5px; font-size:11px" @click="resetAll">
              <b-icon icon="arrow-clockwise" />
              {{$ml.get('resetAll')}}
            </b-button>
          </span>
      </b-row>
        
      </b-col>

      <!--Keyword/Collections/Types -->
      <b-col class="small" cols="12 col-sm-12 col-lg-4 p-0" >

        <!--Keyword -->
        <b-row class="ml-1 align-items-center" >
          <b-col cols="4 col-md-3" class="p-0"> 
            <b-icon class="mr-1" icon="search" scale="0.9"/>
            <span style="font-size:14px">Keyword</span>
          </b-col>
          <b-col cols="8 col-md-9" style="display:contents" class="p-0">
            <b-badge class="noneBadge toolong pointerC" style="max-width:250px" :variant="(selectedDis === 'all') ? 'light':'dark'" v-if="search !== ''" @click="selectedDis = 'all'">{{search}}</b-badge>
            <b-badge class="noneBadge" v-else> {{$ml.get('resultN')}}</b-badge>              
            <b-badge title="Reset" class='badgeReset' @click="search=''; startTimeoutSearch()" >
              <b-icon icon="arrow-clockwise" />
            </b-badge>

          </b-col>
          
        </b-row>

        <!--Collections -->
        <b-row class="ml-1 align-items-center" >

          <b-col cols="4 col-md-3" class="p-0"> 
            <b-iconstack title="Show collections panel" v-if="!showFilterC" @click="showFilterC = !showFilterC; saveShowCol()" class="darkblue">
              <b-icon stacked icon="collection"/>
              <b-icon stacked icon="plus" scale="0.5" shift-v="-2"/>
            </b-iconstack>
            <b-iconstack title="Hide collections panel" v-else @click="showFilterC = !showFilterC; saveShowCol()" class="greenP">
              <b-icon stacked icon="collection"/>
              <b-icon stacked icon="dash" scale="0.5" shift-v="-2"/>
            </b-iconstack>
            <span class="ml-1" style="font-size:14px">Collections</span>
          </b-col>

          <b-col cols="8 col-md-9" class="p-0"> 
            <b-badge v-if="selectedCollections.length !== 0" class="collectBadgeSel" :title="selectedCollections.length+' selected collection(s)'">
              <b-iconstack>
                <b-icon stacked icon="collection" />
                <b-icon stacked icon="check2" shift-h="2" shift-v="-1" scale="0.9" />
              </b-iconstack>
              {{selectedCollections.length}}
            </b-badge> 
            <b-badge v-if="exludedCollections.length !== 0" class="collectBadgeExl" :title="exludedCollections.length+' excluded collection(s)'">
              <b-iconstack>
                <b-icon stacked icon="collection" />
                <b-icon stacked icon="x" shift-v="-1" scale="0.9" />
              </b-iconstack>
              {{exludedCollections.length}}
            </b-badge> 
            <b-badge v-if="exludedCollections.length === 0 && selectedCollections.length === 0" class="noneBadge">{{$ml.get('resultN')}}</b-badge>

            <b-badge title="Show collections panel" class="badgenoneshow" @click="showFilterC = !showFilterC; saveShowCol()" v-if="!showFilterC" >+</b-badge>
            <b-badge title="Hide collections panel" class="badgenonehide" @click="showFilterC = !showFilterC; saveShowCol()" v-else >-</b-badge>
            <b-badge title="Reset" class='badgeReset' @click="selectedCollections=[]; exludedCollections=[]; startTimeoutSearch()" >
              <b-icon icon="arrow-clockwise" />
            </b-badge>
            <!--
            <b-icon v-if="selectedCollections.length !== 0" class="green" icon="circle-fill" scale="0.65" ></b-icon>
            <b-icon v-else-if="exludedCollections.length !== 0" class="red" icon="circle-fill" scale="0.65" ></b-icon>
            <span class="tag-selected">
              <strong>Selected: {{selectedCollections.length}}</strong>
            </span>-->
          </b-col>

        </b-row>

        <!--Types -->
        <b-row class="ml-1 align-items-center" >

          <b-col cols="4 col-md-3" class="p-0"> 
            <b-iconstack title="Show Types panel" v-if="!showFilterT" @click="showFilterT = !showFilterT; saveShowFil()" class="darkblue">
              <b-icon stacked icon="layers-half"/>
              <b-icon stacked icon="plus" scale="0.5" shift-v="2"/>
            </b-iconstack>
            <b-iconstack title="Hide Types panel" v-else @click="showFilterT = !showFilterT; saveShowFil()" class="greenP">
              <b-icon stacked icon="layers-half"/>
              <b-icon stacked icon="dash" scale="0.5" shift-v="2"/>
            </b-iconstack>
            <span class="ml-1" style="font-size:14px">Types</span>
          </b-col>

          <b-col cols="8 col-md-9" class="p-0">
            <b-badge class="transBadge" title="Filter applied on Video Types" v-if="!defaultAdvancedFilters">
              <b-icon class="blueV" icon="circle-fill" ></b-icon>
            </b-badge>
            <b-badge class="transBadge" title="Filter applied on Video Qualities" v-if="!defaultQFilters">
              <b-icon class="blueQ" icon="circle-fill" ></b-icon>
            </b-badge>
            <b-badge class="transBadge" title="Filter applied on [Config]" v-if="selectedKey">
              <b-icon class="blueC" icon="circle-fill" ></b-icon>
            </b-badge>
            <b-badge class="runningVidsBadgeWO" v-if="isRunningOnly" title="Only active vids (in the last 5min) are displayed" >
              {{$ml.get('only5')}}
              <b-icon icon="eye-fill" class="red"/>
            </b-badge>
            <b-badge class="hiddenAuthBadgeWO" v-if="seeHidden && totalNumberVideoHidden > 0" title="Hidden videos are displayed" >
              {{$ml.get('hiddenshown')}}
              <b-icon icon="eye-fill" />
            </b-badge>

            <b-badge v-if="!isRunningOnly && (!seeHidden || totalNumberVideoHidden === 0) && !selectedKey && defaultQFilters && defaultAdvancedFilters" class="noneBadge">{{$ml.get('resultN')}}</b-badge>
            <b-badge title="Show Types panel" class="badgenoneshow" @click="showFilterT = !showFilterT; saveShowFil()" v-if="!showFilterT" >+</b-badge>
            <b-badge title="Hide Types panel" class="badgenonehide" @click="showFilterT = !showFilterT; saveShowFil()" v-else >-</b-badge>
            <b-badge title="Reset" class='badgeReset' @click="resetTypesF" >
              <b-icon icon="arrow-clockwise" />
            </b-badge>

          </b-col>

        </b-row> <!-- End of Types in Display -->

      </b-col>
      <!--End of Keyword/Collections/Types in Display-->

      <!--Videos displayed -->
      <b-col cols="12 col-sm-12 col-lg-2" :class="(selectedDis === 'all' ) ? 'backDisG':'backDisD'" class="mt-3 mb-3 p-2" @click="selectedDis = 'all'">

        <span v-if="search !== '' || selectedCollections.length !== 0 || exludedCollections.length !== 0 || !defaultAdvancedFilters || !defaultQFilters || selectedKey || (totalNumberVideoHidden > 0)">
          <span v-if="isRunningOnly" title="ONLY active vids (in the last 5min) are displayed">
            <b-icon class="red" icon="circle-fill" scale="0.5" ></b-icon>
            <b-badge class="mr-1" style="border: 1px solid #ba0000" variant="success"><strong>{{formatNbr(numberOfVideos)}}</strong></b-badge>
            /
            <b-badge class="ml-1" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
          </span>
          <span v-else>
            <b-badge class="mr-1" variant="success"><strong>{{formatNbr(numberOfVideos)}}</strong></b-badge>
            /
            <b-badge class="ml-1" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
          </span>
        </span>
        <span v-else>
          <span v-if="isRunningOnly" title="ONLY active vids (in the last 5min) are displayed">
            <b-icon class="red" icon="circle-fill" scale="0.5" ></b-icon>          
            <b-badge class="ml-1" style="border: 1px solid #ba0000" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
          </span>
          <span v-else>
            <b-badge class="ml-1" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
          </span>
        </span>
        <div class="small">{{$ml.get('pluginvideoplural')}}</div>
      </b-col> <!-- End of Videos displayed -->

      <!-- Active/Hidden/Selected in Display -->
      <b-col cols="12 col-sm-12 col-lg-5" style="font-size:16px">
        
        <!-- Active vids --> 
        <b-row class="m-1 ml-2 align-items-center" >
          <b-col cols="0 col-sm-0 col-md-1"></b-col>
          <b-col cols="6 col-sm-6 col-md-5 p-0">
            <b-badge class="runningVidsBadgeWO" :title="runningVideos.length+' active vids (in the last 5min) in total. Warning: if any filtering is applied, it is not considered for this number'" v-if="isRunningOnly" >{{formatNbr(runningVideos.length)}}</b-badge>
            <b-badge class="runningVidsBadgeDisWO" :title="runningVideos.length+' active vids (in the last 5min) in total. Warning: if any filtering is applied, it is not considered for this number'" v-else >{{formatNbr(runningVideos.length)}}</b-badge>
            <small class="ml-1">{{$ml.get('vidsrunning')}}</small>
            <small style="font-size:10px">{{$ml.get('last5')}}</small>
            <small><b-icon id="popover-helpRun" class="pointerC ml-1" icon="exclamation-circle" /></small>
            <b-popover
                target="popover-helpRun"
                triggers="click"
                placement="bottomright"
                >
                {{$ml.get('helpshowrun')}} 
              </b-popover>
          </b-col>
          <b-col cols="6 p-0">
            <b-badge class="runningVidsBadge" @click="isRunningOnly = !isRunningOnly; saveShowActive()" v-if="isRunningOnly">
                {{$ml.get('showactiveonlyDis')}}
                <b-icon icon="eye-fill" class="red"/>
                &nbsp;<b-icon icon="check2-square" class="red"/>
            </b-badge>
            <b-badge class="runningVidsBadgeDis" @click="isRunningOnly = !isRunningOnly; saveShowActive()" v-else>
                {{$ml.get('showactiveonlyDis')}}
                <b-icon icon="eye-fill" class="red"/>
                &nbsp;<b-icon icon="square"/>
            </b-badge>
          </b-col>
        </b-row>

        <!-- Hidden vids -->
        <b-row v-if="totalNumberVideoHidden > 0" class="m-1 ml-2 align-items-center" >
          <b-col cols="0 col-sm-0 col-md-1"></b-col>
          <b-col cols="6 col-sm-6 col-md-5 p-0">
            <b-badge class="hiddenAuthBadgeDisWO" :title="totalNumberVideoHidden+' hidden video(s) in total. Warning: if any filtering is applied, it is not considered for this number'" v-if="!seeHidden" >{{formatNbr(totalNumberVideoHidden)}}</b-badge>
            <b-badge class="hiddenAuthBadgeWO" :title="totalNumberVideoHidden+' hidden video(s) in total. Warning: if any filtering is applied, it is not considered for this number'" v-else >{{formatNbr(totalNumberVideoHidden)}}</b-badge>
            <small class="ml-1">{{$ml.get('vidshidden')}}</small>
            <small><b-icon id="popover-helphid2" class="pointerC ml-1" icon="exclamation-circle" /></small>
            <b-popover
              target="popover-helphid2"
              triggers="click"
              placement="bottomright"
              >
              {{$ml.get('helphidnbr')}} 
            </b-popover>

          </b-col>
          <b-col cols="6 p-0">
            <b-badge class="hiddenAuthBadge" @click="seeHidden = !seeHidden; refreshManual()" v-if="seeHidden" title="Hidden videos are not displayed">
                {{$ml.get('show')}}
                <b-icon icon="eye-fill"/>
                &nbsp;<b-icon icon="check2-square" />
            </b-badge>
            <b-badge class="hiddenAuthBadgeDis" @click="seeHidden = !seeHidden; refreshManual()" v-else title="Hidden videos are displayed" >
                {{$ml.get('show')}}
                <b-icon icon="eye-fill"/>
                &nbsp;<b-icon icon="square" />
            </b-badge>
          </b-col>
        </b-row >

        <!-- Selected Vids -->
        <b-row v-if="nbrVideoSelected > 0" class="m-1 ml-2 align-items-center small">
          <b-col cols="0 col-sm-0 col-md-1"></b-col>
          <b-col class="12 col-sm-12 col-md-11 p-0">
            <span style="font-size:14px">{{$ml.get('selected')}}</span>
            <b-badge class="mr-1" variant="primary" style="border:solid 1px black;">{{nbrVideoSelected}}</b-badge>
            <b-badge class="hiddenAuthBadgeDis" style="width:auto !important" @click="updateHideVideo()" title="Hide selected videos">
              {{$ml.get('hide')}}
              <b-icon icon="eye-slash-fill" />
            </b-badge>
            <b-badge class="hiddenAuthBadge" style="width:auto !important" @click="updateUnhideVideo()" title="Unhide selected videos">            
              {{$ml.get('unhide')}}
              <b-icon icon="eye-fill" />
            </b-badge>
          </b-col>
        </b-row>

      </b-col> <!-- End of Active/Hidden/Selected in Display -->

    </b-row> <!-- End of Display panel -->

  </b-form><!-- End of Filter panel -->

  <!-- Sort Panel
  <b-form class="borderRL borderT mt-2" style="border-bottom:solid 1px #2a5d77" >

    <b-row class="align-items-center m-3 h6">

      <!-- Sort title 
      {{$ml.get('selectsort')}}
      <b-form-select v-if="selectedDis === 'all'" size="sm" class="greenwSel" v-model="activeSort" :options="activeSortTable" v-on:input="changeActiveSort(activeSort)" >
      </b-form-select>
      <b-form-select v-else size="sm" class="greenwSel" v-model="activeSort" :options="topSortTable" v-on:input="updateTop()" >
      </b-form-select>
      <span v-if="selectedDis === 'all'">
        <b-button size="sm" v-if="activeSort === 'videoIDMin'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort(activeSort, -1)" variant="darkblue">
          <font-awesome-icon v-if="activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']" ></font-awesome-icon> 
          <font-awesome-icon v-else :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" v-else style="margin-left:2px; margin-right:2px" @click="changeActiveSort(activeSort, 1)" variant="darkblue">
          <font-awesome-icon v-if="activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']" ></font-awesome-icon> 
          <font-awesome-icon v-else :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
      </span>

    </b-row>


    <!--
    <b-row class="justify-content-center align-items-center ml-1 mr-1">


      <!-- List of Sorting buttons -->
        <!-- Div to scroll horizontally -->
      <!--
        <div class="scrollmenu" style="padding-bottom: 10px">
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:0px; margin-right:2px" @click="changeActiveSort('videoIDMin')" :variant="(activeSort === 'videoIDMin') ? 'greenw':'darkblue'">
            <b-icon icon="align-top" />
            {{$ml.get('title')}}
            <font-awesome-icon v-if="activeSort === 'videoIDMin' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
            <font-awesome-icon v-if="activeSort === 'videoIDMin' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('createdDate', -1)" :variant="(activeSort === 'createdDate') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'calendar-minus']"></font-awesome-icon> 
            {{$ml.get('creationdate')}} 
            <font-awesome-icon v-if="activeSort === 'createdDate' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'createdDate' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>    
          
          <b-button size="sm" title="Sort by current number of qualities" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('currentNumberOfQualities', -1)" :variant="(activeSort === 'currentNumberOfQualities') ? 'greenw':'darkblue'">
            {{$ml.get('qnbr')}}
            <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>        
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('hourview', -1)" :variant="(activeSort === 'hourview') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
            {{$ml.get('viewingtime')}}
            <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('meanTime', -1)" :variant="(activeSort === 'meanTime') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon>
            {{$ml.get('meanvd')}}
            <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>          
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('bitrate', -1)" :variant="(activeSort === 'bitrate') ? 'greenw':'darkblue'">
            &#x7E; {{$ml.get('bitrate')}}
            <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('bestQualityPercent', -1)" :variant="(activeSort === 'bestQualityPercent') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon> 
            {{$ml.get('topq')}}
            <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('concurrentUsers', -1); updateTop()" :variant="(activeSort === 'concurrentUsers') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon> 
            {{$ml.get('viewers')}}
            <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('rebuff'); updateTop()" :variant="(activeSort === 'rebuff') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>           
            {{$ml.get('rebuff')}}
            <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('ttfb_total', -1); updateTop()" :variant="(activeSort === 'ttfb_total') ? 'greenw':'darkblue'">
            <b-icon scale="0.8" icon="clock-fill" />
            TTFB
            <font-awesome-icon v-if="activeSort === 'ttfb_total' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'ttfb_total' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('offload', -1); updateTop()" :variant="(activeSort === 'offload') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon> 
            {{$ml.get('eff')}}
            <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('totalMB_peer', -1); updateTop()" :variant="(activeSort === 'totalMB_peer') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
            {{$ml.get('dataoutp')}}
            <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('dataDelivered', -1); updateTop()" :variant="(activeSort === 'dataDelivered') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon> 
            {{$ml.get('dataout')}}
            <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('energySaved', -1)" :variant="(activeSort === 'energySaved') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'leaf']" ></font-awesome-icon> 
            {{$ml.get('energy')}}
            <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('kwhSaved')" :variant="(activeSort === 'kwhSaved') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'plug']" style="color:#14BF98"></font-awesome-icon> 
            {{$ml.get('KWhSaved')}}
            <font-awesome-icon v-if="activeSort === 'kwhSaved' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'kwhSaved' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" :disabled="selectedDis !== 'all'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('kwhSpent')" :variant="(activeSort === 'kwhSpent') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon> 
            {{$ml.get('KWh')}}
            <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <!--
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('co2Spent')" :variant="(activeSort === 'co2Spent') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon> 
            {{$ml.get('carbon')}}
            <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
          </b-button>
          <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('collections')" :variant="(activeSort === 'collections') ? 'greenw':'darkblue'">
            <font-awesome-icon :icon="['fas', 'tags']"></font-awesome-icon> 
            {{$ml.get('tags')}}
            <font-awesome-icon v-if="activeSort === 'collections' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon> 
            <font-awesome-icon v-if="activeSort === 'collections' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
          </b-button>
          
        </div> <!-- End of Div to scroll horizontally 
    </b-row> <!-- End of Sorting buttons -->

    <!-- Mesg about the period 
    <b-row class="mr-3 ml-3 mt-1 mb-2">
      <p style="font-size: 70%" v-text="$ml.get('last24p')"></p>
    </b-row>
  </b-form> <!-- End of Sort panel -->

  <!-- Look/Refresh panel -->
  
  <b-form class="mb-2 mt-2 p-2 borderRL borderT" style="border-bottom: 1px solid #2a5d77;">

    <b-row class="justify-content-between align-items-center">
      <!-- Look/Refresh left part -->
      <b-col cols="12 col-sm-12 col-xl-3 p-0">

        <b-row class="m-1 justifCC">
          <b-col cols="col-sm-6 m-0 mb-1 pr-0">            
            <b-button size="sm" style="width:250px; font-size:small" v-if="authorizedRead" variant="msstreamblue" @click="updateVideoPluginList()" :title="$ml.get('timeloadnewvideos')">
              <b-iconstack>
                <b-icon icon="play-fill" scale="0.5" shift-h="-4" shift-v="3" />
                <b-icon icon="search" shift-h="-3" shift-v="2" scale="0.8"/>
              </b-iconstack>
              {{$ml.get('loadnewvideos')}}
            </b-button>
            <b-icon class="pointerC" id="popover-help2" style="margin-left: 0.2rem" icon="exclamation-circle" />
            <b-popover
              target="popover-help2"
              triggers="click"
              placement="bottomright"
              >
              {{$ml.get('timeloadnewvideos')}} 
            </b-popover>
          </b-col>
          <b-col cols="col-sm-6 m-0 mt-1 pr-0">
            <b-button v-if="selectedDis === 'all'" size="sm" style="width:250px; font-size:small" variant="mswarning" @click="getVideos()" title="Refresh below list only, not looking for new videos.">
              <b-icon icon="arrow-repeat" />
              {{$ml.get('refresh')}}
            </b-button>
            <b-button v-else size="sm" style="width:250px; font-size:small" variant="mswarning" @click="classicDate()" title="Refresh below list only, not looking for new videos.">
              <b-icon icon="arrow-repeat" />
              {{$ml.get('refresh')}}
            </b-button>
          </b-col>
        </b-row>
      </b-col>

      <!-- Number/page part -->
      <b-col cols="12 col-sm-12 col-xl-6" class='marginNbrVids' style="text-align:center">
        <b-row class="justify-content-center align-items-center h6 mb-1">

          <b-button size="sm" :variant="(selectedDisplay === 'mosaic' ) ? 'greenw':'darkblue'" @click="selectedDisplay = 'mosaic', saveDisplayParameters()" title="Mosaic">
            <font-awesome-icon :icon="['fas', 'th']"></font-awesome-icon>
          </b-button>
          <b-button class="m-1" size="sm" :variant="(selectedDisplay === 'list') ? 'greenw':'darkblue'" @click="selectedDisplay = 'list'; saveDisplayParameters()" title="List">
            <font-awesome-icon :icon="['fas', 'list']"></font-awesome-icon>
          </b-button>

          &#xFF5C;

          <b-button class="m-1" size="sm" :variant="(selectedDis === '20' || selectedDis === '50' ) ? 'greenw':'darkblue'" @click="activateTop(20); saveDisplayParameters()" title="Top Videos">
            <span v-if="isRunningOnly" title="ONLY active vids (in the last 5min) are displayed">
              <b-icon class="red" icon="circle-fill" scale="0.5" ></b-icon>
            </span>
            Top 
            <b-badge pill variant="danger">20</b-badge>
          </b-button>
          <b-button class="m-1" size="sm" :variant="(selectedDis === 'all' ) ? 'greenw':'darkblue'" @click="selectedDis = 'all'; changeActiveSort(); saveDisplayParameters()" title="All">
            All
            <span v-if="search !== '' || selectedCollections.length !== 0 || exludedCollections.length !== 0 || !defaultAdvancedFilters || !defaultQFilters || selectedKey || (totalNumberVideoHidden > 0)">
              <span v-if="isRunningOnly" title="ONLY active vids (in the last 5min) are displayed">
                <b-icon class="red" icon="circle-fill" scale="0.5" ></b-icon>
                <b-badge class="mr-1" style="border: 1px solid #ba0000" variant="success"><strong>{{formatNbr(numberOfVideos)}}</strong></b-badge>
                /
                <b-badge class="ml-1" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
              </span>
              <span v-else>
                <b-badge class="mr-1" variant="success"><strong>{{formatNbr(numberOfVideos)}}</strong></b-badge>
                /
                <b-badge class="ml-1" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
              </span>
            </span>
            <span v-else>
              <span v-if="isRunningOnly" title="ONLY active vids (in the last 5min) are displayed">
                <b-icon class="red" icon="circle-fill" scale="0.5" ></b-icon>
                <b-badge class="ml-1" style="border: 1px solid #ba0000" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
              </span>
              <span v-else>
                <b-badge class="ml-1" variant="info">{{formatNbr(totalNumberOfVideos)}}</b-badge>
              </span>
            </span>

          </b-button>

          &#xFF5C;

          {{$ml.get('selectsort')}}
          <b-form-select v-if="selectedDis === 'all'" size="sm" class="greenwSel m-1" v-model="activeSort" :options="activeSortTable" v-on:input="changeActiveSort(activeSort)" >
          </b-form-select>
          <b-form-select v-if="selectedDis !== 'all'" size="sm" class="greenwSel m-1" v-model="activeSort" :options="topSortTable" v-on:input="forceUpdateTop();" >
          </b-form-select>
          <span v-if="selectedDis === 'all'">
            <b-button size="sm" v-if="activeSort === 'videoIDMin'" style="margin-left:2px; margin-right:2px" @click="changeActiveSort(activeSort, -1)" variant="darkblue">
              <font-awesome-icon v-if="activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']" ></font-awesome-icon> 
              <font-awesome-icon v-else :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
            </b-button>
            <b-button size="sm" v-else style="margin-left:2px; margin-right:2px" @click="changeActiveSort(activeSort, 1)" variant="darkblue">
              <font-awesome-icon v-if="activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']" ></font-awesome-icon> 
              <font-awesome-icon v-else :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
            </b-button>
          </span>

        </b-row>

        <b-row class="justify-content-center align-items-center small m-0" v-if="videos.length !== undefined && realTotalNumberOfPage > 1 && selectedDis === 'all'">
          <b-dropdown size="sm" style="z-index:1; margin: 5px 1rem" id="dropdown-2" v-bind:text="numberPerPage + ' / page'" variant="quanteeclg">
            <b-dropdown-item v-bind:class="numberPerPage === 20" @click="numberPerPage=20; currentPage = 1; getVideos()">20</b-dropdown-item>
            <b-dropdown-item v-bind:class="numberPerPage === 50" @click="numberPerPage=50; currentPage = 1; getVideos()">50</b-dropdown-item>
            <b-dropdown-item v-bind:class="numberPerPage === 100" @click="numberPerPage=100; currentPage = 1; getVideos()">100</b-dropdown-item>
          </b-dropdown>
        
          <b-pagination 
            size="sm"
            v-if="videos.length !== undefined && realTotalNumberOfPage > 1 && selectedDis === 'all'"
            :limit="8" 
            align="center"
            :total-rows="realTotalNumberOfPage" 
            v-model="currentPage" 
            :per-page="1" 
            style="margin: 5px"
            first-number last-number 
            @input="getVideos()">
          </b-pagination>
        </b-row>
      </b-col>

      <!-- Time range part -->
      <b-col cols="12 col-sm-12 col-xl-3 mt-2 mb-2">
        <b-row class="align-items-center justify-content-center mb-2">
          <small>{{$ml.get('timerangeVLP')}}</small>
          <b-form-select class="timeSelDis" size="sm" disabled v-if="selectedDis === 'all'" title="Available for Top20 and Top50 only" v-model="dateLabeldef" v-on:input="calendarValidate = false" >
            <b-form-select-option :value="null">{{defaultdate}} 00:00-23:59</b-form-select-option>
          </b-form-select>
          <b-form-select class="timeSel" size="sm" v-else v-model="dateLabel" :options="dateLabelOptions" v-on:input="classicDate(); calendarValidate = false" ></b-form-select>
          <b-icon class="pointerC" id="popover-helpTR" style="margin-left: 0.2rem" icon="exclamation-circle" 
          v-b-popover.click.html="{content:$ml.get('timeRangePop')}"
          />
        </b-row>

        <b-row class="justify-content-center" v-if="selectedDis !== 'all'" style="background-color: transparent">
          <date-picker v-model="range" @input="calendarValidate = true" is-range is24hr mode="dateTime" :timezone="''" >
            <template v-slot="{ inputEvents }">
              <b-row class="justify-content-center" style="min-width: 310px">
                <b-button class="small" size="sm" style="border-top-right-radius:0px !important; border-bottom-right-radius:0px !important" variant="quanteeclg" v-on="inputEvents.start">
                  <font-awesome-icon :icon="['fas', 'calendar-week']"></font-awesome-icon>&nbsp;
                  {{dateStart}} - {{dateEnd}}
                </b-button>
                <b-button class="small" size="sm" style="border-top-left-radius:0px !important; border-bottom-left-radius:0px !important" variant="quanteeclg" v-if="calendarValidate" @click="calendarValidate=false; updateTop(), dateLabel='custom'" >
                  <font-awesome-icon style="color:green" :icon="['fas', 'check']"></font-awesome-icon>
                </b-button>
                <b-button class="small" size="sm" style="border-top-left-radius:0px !important; border-bottom-left-radius:0px !important" variant="quanteeclg" v-else disabled>
                  <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
                </b-button>
              </b-row>
            </template>
          </date-picker>
        </b-row>
      </b-col>

    </b-row>
  </b-form> <!-- End of Look/Refresh panel -->

  <b-row v-if="isGetInProgress || isGetTopInProgress" class="justify-content-center m-5">
    <fade-loader color="#f98e35" style="position: relative; width: 45px; height: 60px; margin: auto; text-align: center"></fade-loader>
  </b-row>

  <b-table
    class="small"
    style="text-align: center"
    show-empty
    centered
    responsive
    striped
    bordered
    :fields="topsTable"
    :items="rankingTable"
    v-if="selectedDisplay === 'list' && selectedDis !== 'all'" 
  >

    <template #cell(index)="data">
      <span>

        <b-badge pill variant="danger">{{ data.index + 1 }}</b-badge>

      </span>
    </template>

    <template #head()="data">
      <span v-if="sortOn === 'concurrentUsers' && data.label === 'Max. viewers'" class="green">{{ data.label }} </span>
      <span v-else-if="sortOn === 'rebuff' && data.label === 'Rebuff. %'" class="green">{{ data.label }} </span>
    </template>

    <template #head(videoID)="data">
      <span :class="(activeSort === 'videoIDMin') ? 'green':''" >
        {{data.label}}
      </span>
      &#xFF5C;

      <span v-if="showDetailsRow === true">
        <b-icon class="pointerEltSB" icon="dash-circle" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" />
      </span>
      <span v-else>
        <b-icon class="pointerEltSB" icon="plus-circle" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" />
      </span>

    </template>

    <template #head(offload_unit)="data">
      <span :class="(sortOn === 'offload') ? 'green':''" >
        {{data.label}}
      </span>
      
      <div class="small mt-1">
        <span :class="(sortOn === 'totalMB_peer') ? 'green':''" >
          P2P data 
        </span>
        / 
        <span :class="(sortOn === 'dataDelivered') ? 'green':''" >
          Total data
        </span>
      </div>
    </template>

    <template v-slot:cell(concurrentUsers)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(sortOn === 'concurrentUsers') ? 'selectCol':''" >
          {{item.concurrentUsers}}
        </span>

      </span>
    </template>
    
    <template v-slot:cell(rebuff)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(sortOn === 'rebuff') ? 'selectCol':''" >
          {{item.rebuff}}
        </span>

      </span>
    </template>

    <template v-slot:cell(offload_unit)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(sortOn === 'offload') ? 'selectCol':''" >
          {{item.offload_unit}}
        </span>
        <div class="small mt-1">
          <span :class="(sortOn === 'totalMB_peer') ? 'selectCol':''" >
            {{item.totalMB_peer_unit}}
          </span> 
          / 
          <span :class="(sortOn === 'dataDelivered') ? 'selectCol':''" >
            {{item.dataDelivered_unit}}
          </span>
        </div>

      </span>
    </template>

    <template v-slot:cell(videoID)="{ item }">

      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">
      
        <b-row class="mr-1 justify-content-between align-items-center">
          <b-col cols="11 p-0" style="text-align:left !important">

            <span class="pointerC" style="color: #ba0000; margin-right:5px" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" v-if="runningVideos.findIndex(x => x.videoID === item.videoID) !== -1">
              <b-icon icon="play-fill" rotate="90" v-if="showDetailsRow" title="Active during the last 5min" />
              <b-icon icon="play-fill" v-else title="Active during the last 5min" />
            </span>
            <span class="pointerC" style="margin-right:5px" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" v-if="runningVideos.findIndex(x => x.videoID === item.videoID) === -1">
              <b-icon icon="play-fill" rotate="90" v-if="showDetailsRow" title="Inactive during the last 5min" />
              <b-icon icon="play-fill" v-else title="Inactive during the last 5min" />
            </span>

            <span :class="(sortOn === 'videoIDMin') ? 'selectCol':''" >
              {{item.videoID}}
            </span>
            <span v-if="item.isHidden" class="hiddenAuthBadge" style="padding:2px 10px; margin:0px; width:auto !important">
              <small>{{$ml.get('hidden')}}</small>
            </span>

          </b-col>
          <b-col class="p-0">
            <b-badge pill variant="danger" v-if="item.stream_type === 'live'">LIVE</b-badge>
            <b-badge pill variant="info" v-if="item.stream_type === 'vod'">VOD</b-badge>
          </b-col>          
        </b-row>

        <b-row class="align-items-center" style="font-size: 12px; margin: 0.75rem 0.25rem" v-if="showDetailsRow" >
          <b-col cols="11 p-0" style="text-align:left !important">

            <span :class="(sortOn === 'createdDate') ? 'selectCol':''" >
              <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
              <span v-if="item._created && item._created !== ''"> {{ item._created }}</span>
              <span v-else class="ml-1" >
                <b-iconstack >
                  <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
                  <b-icon icon="search"/>
                </b-iconstack>
              </span>
            </span>

            &#xFF5C;
            <span class="tag-config pointerElt pr-2 pl-2" v-if="(configurations.findIndex(x => x.key === item.key) > -1)" @click="$router.push('/config?start=' + configurations.find(x => x.key === item.key).name)" :title="'Config used: '+configurations.find(x => x.key === item.key).name">
              <b-icon icon="gear-fill"/>
              {{configurations.find(x => x.key === item.key).name}}
            </span>
            <span v-else >
              <b-iconstack >
                <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
                <b-icon icon="search"/>
              </b-iconstack>
            </span>

            <span class="pointerC" v-if="item.rules && !item.rulesFromCollection" @click="selectedVideo = video; showModal('authorizations')" title="See Custom Params" > 
              &#xFF5C;
              <b-icon icon="cast" class="mr-1" />
              Custom
            </span>

            &#xFF5C;
            <b-icon class="pointerC ml-1" color="orange" icon="arrows-fullscreen" @click = "search = item.videoID; isGetInProgress=true; onSearchBar(); selectedDis = 'all'" />

          </b-col>
          <b-col v-if="item.protocol && item.seg_ext" class="p-0">
            {{item.protocol}}({{item.seg_ext}})
          </b-col>          

        </b-row>

        <b-row class="m-1 align-items-center" v-if="showDetailsRow" >
          <small>
            {{$ml.get('qnbr')}}:
            {{item.q_nbr || 'N/A'}}
            - Res.:&nbsp;
            <b-badge class="mr-1" v-if="item.isSD" style="font-size:10px; background-color:#ba0000; padding:5px" title="SD res. viewed" >SD</b-badge>
            <b-badge class="mr-1" v-if="item.isHD" style="font-size:10px; background-color:#ba008f; padding:5px" title="HD res. viewed" >HD</b-badge>
            <b-badge class="mr-1" v-if="item.isFullHD" style="font-size:10px; background-color:#2F90B0; padding:5px" title="Full HD 1080p res viewed" >1080p</b-badge>
            <b-badge class="mr-1" v-if="item.is2K" style="font-size:10px; background-color:#aac8d4; padding:5px" title="2K 1440p res. viewed" >2K</b-badge>
            <b-badge class="mr-1" v-if="item.is4K" style="font-size:10px; background-color:rgb(20, 191, 152); padding:5px" title="4K 2160p res. viewed" >4K</b-badge>
            <b-badge class="mr-1" v-if="!item.currentNumberOfQualities || item.currentNumberOfQualities === '0'" style="font-size:11px; padding:5px">0</b-badge>
            <b-iconstack scale="1.3" v-if="!item.currentNumberOfQualities || item.currentNumberOfQualities === '0'" >
              <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
              <b-icon icon="search"/>
            </b-iconstack>
            &#xFF5C;

            &#x7E;{{$ml.get('bitrate')}}: 
            {{item.bitrate_unit || '0 kbps'}}
            &#xFF5C;

            {{$ml.get('segduration')}}:
            {{item.seg_dur || 'N/A'}}
            &#xFF5C;

            {{$ml.get('segnbr')}}:
            {{item.seg_nbr || 'N/A'}}
          </small>
        </b-row>

        <b-row class="m-1 mt-2 align-items-center" v-if="item.collections && item.collections.length > 0 && showDetailsRow" style="text-align:left; font-size:12px" >
          <small>
            <div style="display: inline-block; margin-right: 3px" v-for="collection in item.collections" v-bind:key="collection">
              <div :class="{'tag-not-selected': (selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1), 'tag-selected': selectedCollections.indexOf(collection) > -1, 'tag-excluded': exludedCollections.indexOf(collection) > -1 }" :title='collection'>
                <span @click="selectCollection(collection)">
                  <b-icon v-if="selectedCollections.indexOf(collection) === -1" icon="collection" style="margin-right: 2px" />
                  <b-iconstack v-if="selectedCollections.indexOf(collection) > -1" style="margin-right: 2px">
                    <b-icon stacked icon="collection" />
                    <b-icon stacked icon="check2" shift-h="2" shift-v="-1" scale="0.9" />
                  </b-iconstack>
                  {{collection}}
                </span>
              </div>
              <b-icon icon="graph-up" class="rounded iconStyle mb-1" font-scale="1.2" @click="$router.push('/analytics?video='+ item.videoID +'&collection=' + collection +'&config='+configurations.find(x => x.key === item.key).name+'&key=' + item.key + '&title=videoconfigcollection')" title="Show analytics for the video within this collection" /> 
            </div>
          </small>
        </b-row>

      </span>

    </template>

    <template v-slot:cell(actions)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">
        <b-btn size="sm" variant="db-sb" @click="openAnalyticsForVideo(item)" title="Go to video analytics page on this video" >
          <b-icon scale="0.8" icon="graph-up" />
        </b-btn>
      </span>
    </template>
  </b-table>

  <b-table
    style="text-align:center; font-size:small"
    show-empty
    centered
    responsive
    striped
    bordered
    :fields="videosTable"
    :items="videos"
    v-if="selectedDisplay === 'list' && selectedDis === 'all'" 
  >
    <template #cell(index)="data">
      <span>

        <b-badge variant="info" >
          {{ data.index + 1 + (currentPage - 1) * numberPerPage }}
        </b-badge>

      </span>
    </template>

    <template #head()="data">
      <span v-if="activeSort === 'concurrentUsers' && data.label === 'Max. viewers'" class="green">{{ data.label }} </span>
      <span v-else-if="activeSort === 'rebuff' && data.label === 'Rebuff. %'" class="green">{{ data.label }} </span>
      <span v-else-if="activeSort === 'ttfb_total' && data.label === 'TTFB'" class="green">{{ data.label }} </span>
    </template>

    <template #head(videoID)="data">
      <span :class="(activeSort === 'videoIDMin') ? 'green':''" >
        {{data.label}}
      </span>
      &#xFF5C;

      <span v-if="showDetailsRow === true">
        <span :class="(activeSort === 'createdDate') ? 'green':''" >
          Creation date
        </span>
        &#xFF5C;
        <b-icon class="pointerEltSB" icon="dash-circle" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" />
      </span>
      <span v-else>
        <span v-if="activeSort === 'createdDate'" >
          <span class="green">Creation date</span>
          &#xFF5C;
        </span>
        <b-icon class="pointerEltSB" icon="plus-circle" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" />
      </span>

    </template>

    <template #head(offload_unit)="data">
      <span :class="(activeSort === 'offload') ? 'green':''" >
        {{data.label}}
      </span>      
      <div class="small mt-1">
        <span :class="(activeSort === 'totalMB_peer') ? 'green':''" >
          P2P data 
        </span>
        / 
        <span :class="(activeSort === 'dataDelivered') ? 'green':''" >
          Total data
        </span>
      </div>
    </template>

    <template #head(energySaved_unit)="data">
      <span :class="(activeSort === 'energySaved') ? 'green':''" >
        {{data.label}}
      </span>      
      <div class="small mt-1">
        <span :class="(activeSort === 'kwhSaved') ? 'green':''" >
          kWh saved 
        </span>
        / 
        <span :class="(activeSort === 'kwhSpent') ? 'green':''" >
          kWh spent
        </span>
      </div>
    </template>

    <template v-slot:cell(concurrentUsers)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(activeSort === 'concurrentUsers') ? 'selectCol':''" >
          {{item.concurrentUsers || 0}}
        </span>

      </span>
    </template>

    <template v-slot:cell(ttfb_total_unit)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(activeSort === 'ttfb_total') ? 'selectCol':''" >
          {{item.ttfb_total_unit || 0}}
        </span>

      </span>
    </template>

    <template v-slot:cell(rebuff)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(activeSort === 'rebuff') ? 'selectCol':''" >
          {{item.rebuff_unit || '0 %'}}
        </span>

      </span>
    </template>

    <template v-slot:cell(offload_unit)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(activeSort === 'offload') ? 'selectCol':''" >
          {{item.offload_unit || '0 %'}}
        </span>
        <div class="small mt-1">
          <span :class="(activeSort === 'totalMB_peer') ? 'selectCol':''" >
            {{item.totalMB_peer_unit || 0}}
          </span> 
          / 
          <span :class="(activeSort === 'dataDelivered') ? 'selectCol':''" >
            {{item.dataDelivered_unit || 0}}
          </span>
        </div>

      </span>
    </template>

    <template v-slot:cell(energySaved_unit)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <span :class="(activeSort === 'energySaved') ? 'selectCol':''" >
          {{item.energySaved_unit || '0 %'}}
        </span>
        <div class="small mt-1">
          <span :class="(activeSort === 'kwhSaved') ? 'selectCol':''" >
            {{item.kwhSaved_unit || 0}} 
          </span>
          / 
          <span :class="(activeSort === 'kwhSpent') ? 'selectCol':''" >
            {{item.kwhSpent_unit || 0}}
          </span>
        </div>

      </span>
    </template>

    <template v-slot:cell(videoID)="{ item }">

      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <b-row class="mr-1 justify-content-between align-items-center">
          <b-col cols="11 p-0" style="text-align:left !important">

            <span class="pointerC" style="color: #ba0000; margin-right:5px" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" v-if="runningVideos.findIndex(x => x.videoID === item.videoID) !== -1">
              <b-icon icon="play-fill" rotate="90" v-if="showDetailsRow" title="Active during the last 5min" />
              <b-icon icon="play-fill" v-else title="Active during the last 5min" />
            </span>
            <span class="pointerC" style="margin-right:5px" @click="showDetailsRow = !showDetailsRow; saveShowDetailsRow()" v-if="runningVideos.findIndex(x => x.videoID === item.videoID) === -1">
              <b-icon icon="play-fill" rotate="90" v-if="showDetailsRow" title="Inactive during the last 5min" />
              <b-icon icon="play-fill" v-else title="Inactive during the last 5min" />
            </span>

            <span :class="(activeSort === 'videoIDMin') ? 'selectCol':''" >
              {{item.videoID}}
            </span>
            <span v-if="item.isHidden" class="hiddenAuthBadge" style="padding:2px 10px; margin:0px; width:auto !important">
              <small>{{$ml.get('hidden')}}</small>
            </span>

          </b-col>
          <b-col class="p-0">
            <b-row class="align-items-center justify-content-around">
              <b-badge pill variant="danger" v-if="item.stream_type === 'live'">LIVE</b-badge>
              <b-badge pill variant="info" v-if="item.stream_type === 'vod'">VOD</b-badge>
              <b-form-checkbox v-model="item._isSelected" style="width: 24px; padding-top: 1px" size="sm" @input="updateSelectedNumber"></b-form-checkbox>
            </b-row>
            <!-- Select button -->
          </b-col>
        </b-row>

        <b-row class="m-1 align-items-center" style="font-size: 12px" v-if="showDetailsRow" >
          <b-col cols="11 p-0" style="text-align:left !important">

            <span :class="(activeSort === 'createdDate') ? 'selectCol':''" >
              <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
              {{ item._created }}
            </span>
            &#xFF5C;
            <span class="tag-config pointerElt pr-2 pl-2" v-if="(configurations.findIndex(x => x.key === item.key) > -1) && (item.client && item.client !== '')" @click="$router.push('/config?start=' + configurations.find(x => x.key === item.key).name)" :title="'Config used: '+configurations.find(x => x.key === item.key).name">
              <b-icon icon="gear-fill"/>
              {{configurations.find(x => x.key === item.key).name}}
            </span>
            <span class="pointerC" v-if="item.rules && !item.rulesFromCollection" @click="selectedVideo = video; showModal('authorizations')" title="See Custom Params" > 
              &#xFF5C;
                <b-icon icon="cast" class="mr-1" />
                Custom
            </span>
            &#xFF5C;
            <span>
              <span v-if="!item.rulesFromCollection && item.rules">
                <span class="customParamBadge m-1" style="font-size: 11px;" @click="selectedVideo = item; showModal('authorizations')" title="See Custom Params" >
                  {{$ml.get('pluginvideobound3')}}&nbsp;
                  <b-icon icon="cast" class="mr-1" />
                  <strong>Custom</strong>
                  <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleC" v-if="item._initRuleSelected === 'custom'" />
                </span>
              </span>

              <span v-else-if="item.rulesFromCollection">
                <span class="collectionParamBadge m-1" style="font-size: 11px;" @click="selectedVideo = item; showModal('authorizationsRO')" title="See Collection Params" >
                  {{$ml.get('pluginvideobound2')}}&nbsp;
                  <b-icon icon="collection" />
                  <span class="toolong ml-1" style="max-width:175px; font-weight: bold">{{item.rulesFromCollection}}</span>
                  <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleCol" v-if="item._initRuleSelected !== 'custom' && item._initRuleSelected !== 'configuration'" />
                </span>
              </span>

              <span v-else-if="item.p2pConf && item.p2pConf.value != '' && item.p2pConf._timeElapsed < 300" >
                <span class="collectionParamBadge m-1" style="font-size: 11px;" @click="collectionAuth = collections.find(x=>x.name === item.p2pConf.value); showModal('authorizationsCollectionRO')" title="See Collection Params" >
                  {{$ml.get('pluginvideobound2')}}&nbsp; 
                  <b-icon icon="collection" />
                  <span class="toolong ml-1" style="max-width:175px; font-weight: bold">{{item.p2pConf.value}}</span>
                  <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleCol" />
                </span>            
              </span>

              <span v-else-if="!item.rules && !item.rulesFromCollection">
                <span class="configBadge m-1" style="font-size: 11px;" @click="$router.push('/config?start=' + searchConfig(configurations, item))" title="See Config params" >
                  {{$ml.get('pluginvideobound')}}&nbsp; 
                  <b-icon icon="gear-fill" />
                  <span class="toolong ml-1" style="max-width:175px; font-weight: bold">{{searchConfig(configurations, item)}}</span>
                  <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleConf" v-if="item._initRuleSelected === 'configuration'" />
                </span>
              </span>
            </span>
            &#xFF5C;
            {{$ml.get('confparam')}}:
            <b-form-select size="sm" style="font-size:11px; max-width: 180px" :id="'parametersSelect' + idxVideo" v-model="item._ruleSelected" :options="item._options" @change="inputParametersSelected(item)" :disabled="!authorized"></b-form-select>

          </b-col>
          <b-col v-if="item.protocol && item.seg_ext" class="p-0">
            {{item.protocol}}({{item.seg_ext}})
          </b-col>          

        </b-row>

        <b-row class="m-1 align-items-center" v-if="showDetailsRow" >
          <small>
            {{$ml.get('qnbr')}}:
            {{item.q_nbr || 'N/A'}}
            - Res.:&nbsp;
            <b-badge class="mr-1" v-if="item.isSD" style="font-size:10px; background-color:#ba0000; padding:5px" title="SD res. viewed" >SD</b-badge>
            <b-badge class="mr-1" v-if="item.isHD" style="font-size:10px; background-color:#ba008f; padding:5px" title="HD res. viewed" >HD</b-badge>
            <b-badge class="mr-1" v-if="item.isFullHD" style="font-size:10px; background-color:#2F90B0; padding:5px" title="Full HD 1080p res viewed" >1080p</b-badge>
            <b-badge class="mr-1" v-if="item.is2K" style="font-size:10px; background-color:#aac8d4; padding:5px" title="2K 1440p res. viewed" >2K</b-badge>
            <b-badge class="mr-1" v-if="item.is4K" style="font-size:10px; background-color:rgb(20, 191, 152); padding:5px" title="4K 2160p res. viewed" >4K</b-badge>
            <b-badge class="mr-1" v-if="!item.currentNumberOfQualities || item.currentNumberOfQualities === '0'" style="font-size:11px; padding:5px">0</b-badge>
            <b-iconstack scale="1.3" v-if="!item.currentNumberOfQualities || item.currentNumberOfQualities === '0'" >
              <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
              <b-icon icon="search"/>
            </b-iconstack>
            &#xFF5C;

            &#x7E;{{$ml.get('bitrate')}}: 
            {{item.bitrate_unit || '0 kbps'}}
            &#xFF5C;

            {{$ml.get('segduration')}}:
            {{item.seg_dur || 'N/A'}}
            &#xFF5C;

            {{$ml.get('segnbr')}}:
            {{item.seg_nbr || 'N/A'}}
          </small>
        </b-row>

        <b-row class="m-1 align-items-center" v-if="!showDetailsRow && activeSort === 'createdDate'" >
          <span :class="(activeSort === 'createdDate') ? 'selectCol':''" >
            <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
            {{ item._created }}
          </span>
        </b-row>

        <b-row class="m-1 align-items-center" v-if="showDetailsRow && item.description" >
          <small v-if="!item._modifyDescription" class="pointerDescStyle" @click="item._modifyDescription = !item._modifyDescription; item._desc=item.description; videos = videos.splice(0)" title="Video description, click to modify">
            <span v-if="item.description && item.description !== ''">
              <b-icon icon="file-earmark-text" />
              - {{item.description}}
            </span>
            <span v-else>
              <b-icon icon="file-earmark-text" />
              Description
            </span>
          </small>

          <div v-if="item._modifyDescription">
            <b-form @submit.prevent="updateDescription(item)">
              <b-form-textarea
              id="textarea"
              v-model="item._desc"
              placeholder="Write description here, then Validate"
              style="font-size:85%; height: 30px; min-width: 300px"
              ></b-form-textarea>
            </b-form>
          </div>
          <div v-if="item._modifyDescription">
            <b-button variant="emptyB" @click="updateDescription(item);">
              <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
            </b-button>
            <b-button variant="emptyB" @click="item._modifyDescription = false; item._desc=item.description; videos = videos.splice(0)">
              <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
            </b-button>
          </div>

        </b-row>

        <b-row class="m-1 mt-2 align-items-center" style="text-align:left" v-if="showDetailsRow && item.collections && item.collections.length > 0" >
          <small>
            <div style="display: inline-block; margin-right: 3px" v-for="collection in item.collections" v-bind:key="collection">
              <div :class="{'collection-linked': (item.rulesFromCollection && item.rulesFromCollection === collection)}">
                <div :class="{'tag-not-selected': (selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1), 'tag-selected': selectedCollections.indexOf(collection) > -1, 'tag-excluded': exludedCollections.indexOf(collection) > -1 }" :title='collection'>
                  <span @click="selectCollection(collection)">
                    <b-icon v-if="selectedCollections.indexOf(collection) === -1" icon="collection" style="margin-right: 2px" />
                    <b-iconstack v-if="selectedCollections.indexOf(collection) > -1" style="margin-right: 2px">
                      <b-icon stacked icon="collection" />
                      <b-icon stacked icon="check2" shift-h="2" shift-v="-1" scale="0.9" />
                    </b-iconstack>
                    {{collection}}
                  </span>
                </div>
                <b-icon icon="graph-up" class="rounded iconStyle mb-1" font-scale="1.2" @click="$router.push('/analytics?video='+ item.videoID +'&collection=' + collection +'&config='+configurations.find(x => x.key === item.key).name+'&key=' + item.key + '&title=videoconfigcollection')" title="Show analytics for the video within this collection" /> 
                <b-icon icon="x" class="rounded-circle iconStyleR mb-1" font-scale="1.2" @click="selectedCollection = collection; selectedVideo = item; showModal('removelocalcollection')" title="Remove Collection from video" />
              </div>
            </div>
          </small>
          <b-badge pill class="linkBadge" @click="selectedVideo = item; showModal('linkcollection')">
            <b-icon icon="plus"/>
            {{$ml.get('link')}}
            <b-icon icon="collection"/>
          </b-badge>
        </b-row>
      </span>
    </template>

    <template v-slot:cell(actions)="{ item }">
      <span :class="(isRunningOnly && runningVideos.findIndex(x => x.videoID === item.videoID) === -1) ? 'activeClass':''">

        <b-btn size="sm" variant="db-sb" @click="openAnalyticsForVideo(item)" title="Go to video analytics page on this video" >
          <b-icon scale="0.8" icon="graph-up" />
        </b-btn> 

      </span>
    </template>

  </b-table>

  <!-- Card of each Video -->
  <b-row class="marginB" v-if="selectedDisplay === 'mosaic' && selectedDis !== 'all'">
    <div v-bind:class="{ 
      /*mycard2: (video.rebuff < 20 && !(video.error === true)),
      mycard: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
      mycard4: (video.rebuff >= 50 && !(video.error === true)),*/
      //A vérifier! j'ai enlevé les && x.key === video.key qu'il faudra remettre si on lance le 'look for' auto
      mycardLiveOn: (runningVideos.findIndex(x => x.videoID === video.videoID ) !== -1),
      mycard2: (runningVideos.findIndex(x => x.videoID === video.videoID ) === -1),
      mycard5: ((video.dataDelivered === 0 || !video.hasOwnProperty('dataDelivered')) && runningVideos.findIndex(x => x.videoID === video.videoID ) === -1),
      noDisplay: (isRunningOnly && runningVideos.findIndex(x => x.videoID === video.videoID ) === -1)
    }" class='col-lg-3 col-md-4 col-sm-6 col-12 pr-0 pl-0 pb-2' style="font-size: small; color: #2a5d77" v-for="(video, idxVideo) in rankingTable" v-bind:key="idxVideo">
      
      <!--Icon video + last 5min + Hidden -->
      <b-row class="align-items-center justify-content-between mt-1 ml-3 mr-1" >
        
        <div style="color: #ba0000" v-if="runningVideos.findIndex(x => x.videoID === video.videoID ) !== -1">
          <b-icon icon="play-btn" scale="1.4" title="Active during the last 5min" />
          &nbsp;<small>{{$ml.get('activelast2min')}}</small>
        </div>
        <div v-if="runningVideos.findIndex(x => x.videoID === video.videoID ) === -1">
          <b-icon icon="play-btn" scale="1.4" title="Inactive during the last 5min" />
        </div>

        <div style="text-align:right" v-if="video.isHidden">
          <span class="hiddenAuthBadge" style="padding:2px 10px; margin:0px; width:auto !important">
            <small>{{$ml.get('hidden')}}</small>
          </span>
        </div>
        <div style="text-align:right" v-else>
          <span class="hiddenAuthBadgeNone">
            <small>{{$ml.get('hidden')}}</small>
          </span>
        </div>

      </b-row>

      <!-- Title of the video-->
      <b-row class="ml-3 mr-3 mb-1 align-items-center justify-content-between" style="border-bottom: 1px solid #2F90B0">
        
        <h6 class="toolong" style="margin: 3px 0px; max-width: 94%" :title="'Title of the video: '+video.videoID+'. Corresponding to the analyticsVideoID or videoID mentionned in the configQuanteec object'">
          <strong v-if="activeSort === 'videoIDMin'" style="color:#14BF98">{{video.videoID}}</strong>
          <strong v-else >{{video.videoID}}</strong>
        </h6>

        <b-icon class="pointerEltSB" style="" icon="back" @click="$refs.copied.copyToClipboard(video.videoID);" title="Copy"/> 
        
      </b-row>

      <!-- Author (By) of the video -->
      <b-row class="ml-3 mr-1">
        <span class="toolong pb-3" style="color: #2a5d77">
          {{$ml.get('by')}}
          <strong v-if="video.client && video.client !== ''"> {{video.client}}</strong>
          <strong v-else>
            <b-iconstack scale="1.1" >
              <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
              <b-icon icon="search"/>
            </b-iconstack>
          </strong>
        </span>
      </b-row>

      
      <!-- Video thumbnail -->
      <b-row class="justify-content-center">
        <div @click="openAnalyticsForVideo(video)" class="previewContainer pointerC" style="z-index: 1; background-size: cover; background-repeat: no-repeat; background-image: url('Bg-Th.jpg') ">
          <!--
          <b-img @click="openAnalyticsForVideo(video)" v-if="video.isLive && !video.thumbnailURL"  class="previewImg" style="object-fit:contain; cursor:pointer" :src="require(`@/../public/Bg-Th.jpg`)" @error="imgUrlAlt($event, video)" fluid></b-img>
          <b-img @click="openAnalyticsForVideo(video)" v-if="!video.isLive && !video.thumbnailURL" class="previewImg" style="object-fit:contain; cursor:pointer" :src="require(`@/../public/Bg-Th.jpg`)" @error="imgUrlAlt($event, video)" fluid></b-img>
          <b-img @click="openAnalyticsForVideo(video)" v-if="video.thumbnailURL" class="previewImg" style="object-fit: contain; cursor: pointer" :src="video.thumbnailURL" @error="imgUrlAlt($event, video)" fluid></b-img>
          
          <h6 style="position: absolute; left: 50%; top: 8px">
            <b-badge pill variant="danger">{{ idxVideo + 1 }}</b-badge>
          </h6>
          <h4 style="position: absolute; left: 35%; top: 40%; padding: 10px; border: 1px solid ; color:white; border-radius: 5px; background-color: rgba(255, 255, 255, 0.1)">
              <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120" />
              {{video.offload_unit || '0%'}}
          </h4>-->
          <div style="color: white; position:absolute; z-index:2; left: 0px; top: 0px">
            <b-img v-if="video.stream_type === 'live'" style="width:70px" :src="require(`@/../public/live-icon.png`)" />
            <b-img v-if="video.stream_type === 'vod'" style="width:70px" :src="require(`@/../public/vod-icon.png`)" />
          </div>
          <div v-if="video.protocol && video.seg_ext" style="color: white; position:absolute; z-index:3; right: 5px; top: 5px">
            {{video.protocol}} ({{video.seg_ext}})
          </div>

          <b-row class="justify-content-center m-2 h6">
            <b-badge pill variant="danger">{{ idxVideo + 1 }}</b-badge>
          </b-row>
          <b-row class="justify-content-center m-3 h6">
            <span style="text-align: center; padding: 10px; border: 1px solid rgba(20, 191, 152, 0.3); color: rgba(255, 255, 255, 0.9); border-radius: 5px; background-color: rgba(255, 255, 255, 0.1)">
              <span v-if="activeSort === 'offload'">
                <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120 shrink-4" />
                {{video.offload_unit || '0%'}}
              </span>
              <span v-if="activeSort === 'concurrentUsers'">
                <font-awesome-icon :icon="['fas', 'eye']" transform="shrink-4" /> 
                {{formatNbr(video.concurrentUsers) || '0'}}
              </span>
              <span v-if="activeSort === 'rebuff'">
                <font-awesome-icon :icon="['fas', 'spinner']" transform="shrink-4" />           
                {{video.rebuff || '0%'}}
              </span>
              <span v-if="activeSort === 'dataDelivered'">
                <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4" /> 
                {{video.dataDelivered_unit || '0MB'}}
              </span>
              <span v-if="activeSort === 'totalMB_peer'">
                <font-awesome-icon :icon="['fas', 'users']" transform="shrink-4" />
                {{video.totalMB_peer_unit || '0MB'}}
              </span>
            </span>
          </b-row>
        </div>
      </b-row>

      <!-- Creation date -->
      <b-row class="justify-content-around m-1">
        <b-button size="sm" :variant="(activeSort === 'createdDate') ? 'greenwVLP':'transVLP'">
          <small style="font-size: 12px" title="Video creation date">
            <font-awesome-icon :icon="['fas', 'calendar-minus']" />
            <span v-if="video._created && video._created !== ''"> {{ video._created }}</span>
            <span v-else>
              <b-iconstack scale="0.7" >
                <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
                <b-icon icon="search"/>
              </b-iconstack>
            </span>

          </small>
        </b-button>
      </b-row>

      <!-- Separator between Creation date & Qualities -->
      <div class="separatorCard"></div>

      <!-- Qualities and Avg Bitrate section -->
      <b-row class="justify-content-center align-items-center mt-2 mb-2" style="" title="Only qualities that have been viewed last 24h are shown here">
        {{$ml.get('qnbr')}}:
        {{video.q_nbr || 'N/A'}}
        - Res.:&nbsp;
        <b-badge class="mr-1" v-if="video.isSD" style="font-size:11px; background-color:#ba0000; padding:5px" title="SD quality" >SD</b-badge>
        <b-badge class="mr-1" v-if="video.isHD" style="font-size:11px; background-color:#ba008f; padding:5px" title="HD quality" >HD</b-badge>
        <b-badge class="mr-1" v-if="video.isFullHD" style="font-size:11px; background-color:#2F90B0; padding:5px" title="Full HD 1080p quality" >1080p</b-badge>
        <b-badge class="mr-1" v-if="video.is2K" style="font-size:11px; background-color:#aac8d4; padding:5px" title="2K 1440p quality" >2K</b-badge>
        <b-badge class="mr-1" v-if="video.is4K" style="font-size:11px; background-color:rgb(20, 191, 152); padding:5px" title="4K 2160p quality" >4K</b-badge>          
        <b-badge class="mr-1" v-if="!video.currentNumberOfQualities || video.currentNumberOfQualities === '0'" style="font-size:11px; padding:5px">0</b-badge>
        <b-iconstack scale="1.3" v-if="!video.currentNumberOfQualities || video.currentNumberOfQualities === '0'" >
          <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
          <b-icon icon="search"/>
        </b-iconstack>
      </b-row>

      <b-row class="justify-content-center align-items-center mt-2 mb-2" >
        <small>
          &#x7E;{{$ml.get('bitrate')}}: 
          {{video.bitrate_unit || '0 kbps'}}
        </small>
      </b-row>
      <b-row class="justify-content-around align-items-center mt-2 mb-2" >
        <small>
          {{$ml.get('segduration')}}:
          {{video.seg_dur || 'N/A'}}
        </small>
        <small>
          {{$ml.get('segnbr')}}:
          {{video.seg_nbr || 'N/A'}}
        </small>
      </b-row>

      <!--
      <b-row class="justify-content-center align-items-center mt-0.5 mb-1" >
        <b-button size="sm" :variant="(activeSort === 'bitrate') ? 'greenwVLP':'transVLP'" title="Average video bitrate">
          <small>
            &#x7E;{{$ml.get('bitrate')}}: 
            {{video.bitrate_unit || '0kbps'}}
          </small>
        </b-button>
        &#xFF5C;
        <b-button size="sm" :variant="(activeSort === 'bestQualityPercent') ? 'greenwVLP':'transVLP'" title="Best quality %">
          <small>
            <font-awesome-icon :icon="['fas', 'signal']" />
            {{video.bestQualityPercent_unit || '100%'}}
          </small>
        </b-button>

      </b-row>
      -->
      <!-- Separator between Quality and Analytics sections -->
      <div class="separatorCard"></div>

      <!--1st line of Analytics -->
      <b-row class="justify-content-between align-items-center mt-1 mb-0.25 ml-3 mr-3">

        <b-button size="sm" :variant="(activeSort === 'concurrentUsers') ? 'greenwVLP':'transVLP'">
          <small title="Maximum concurrent viewers over the period">
            <font-awesome-icon :icon="['fas', 'eye']" />
            {{formatNbr(video.concurrentUsers) || '0'}}
          </small>
        </b-button>

        <b-button size="sm" style="margin-left:2px; margin-right:2px" :variant="(activeSort === 'rebuff') ? 'greenwVLP':'transVLP'">
          <small title="Rebuffering %" v-bind:class="{
            green: (video.rebuff < 2 && !(video.error === true)),
            orange: (video.rebuff >= 2 && video.rebuff < 5 && !(video.error === true)),
            red: (video.rebuff >= 5 && !(video.error === true)),
            black: (video.error === true || !video.hasOwnProperty('rebuff')),
            }"
          >
            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon> {{video.rebuff || '0%'}}
          </small>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'ttfb') ? 'greenwVLP':'transVLP'">
          <small title="Time to First Byte">
            <b-icon scale="0.8" icon="clock-fill" />
            {{video.ttfb_total_unit || 'N/A'}}
          </small>
        </b-button>

      </b-row>

      <!--2nd line of Analytics -->
      <b-row class="justify-content-between align-items-center mt-0.25 mb-0.25 ml-3 mr-3">
        <b-button size="sm" :variant="(activeSort === 'offload') ? 'greenwVLP':'transVLP'">
          <small title="Offload %">
            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120" />
            {{video.offload_unit || '0%'}}
          </small>

        </b-button>
        <b-button size="sm" :variant="(activeSort === 'totalMB_peer') ? 'greenwVLP':'transVLP'">
          <small title="Data delivered by peers">
            <font-awesome-icon :icon="['fas', 'users']" />
            {{video.totalMB_peer_unit || '0MB'}}
          </small>

        </b-button>
        <b-button size="sm" :variant="(activeSort === 'dataDelivered') ? 'greenwVLP':'transVLP'">
          <small title="Total data delivered">
            <font-awesome-icon :icon="['fas', 'database']" /> 
            {{video.dataDelivered_unit || '0MB'}}
          </small>
        </b-button>
      </b-row>

      <!--3rd line of Analytics -->
      <!--
      <b-row class="justify-content-between align-items-center mt-0.25 mb-2 ml-3 mr-3">
        <b-button size="sm" :variant="(activeSort === 'energySaved') ? 'greenwVLP':'transVLP'">
          <small title="Energy saved %">
            <font-awesome-icon :icon="['fas', 'leaf']" /> 
            {{video.energySaved_unit || '0%'}}
          </small>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'kwhSaved') ? 'greenwVLP':'transVLP'">
          <small title="KWh saved">
            <font-awesome-icon :icon="['fas', 'plug']" style="color:#14BF98" />
            {{video.kwhSaved_unit || '0Wh'}}
          </small>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'kwhSpent') ? 'greenwVLP':'transVLP'">
          <small title="KWh spent in total">
            <font-awesome-icon :icon="['fas', 'plug']" />
            {{video.kwhSpent_unit || '0Wh'}}
          </small>
        </b-button>
      </b-row>
      -->
      <!-- Analytics button -->
      <b-row class="align-items-center justify-content-around mt-1 mb-2 ml-3 mr-3">
        <b-col cols="auto">
          <b-btn size="sm" variant="db-sb" @click="openAnalyticsForVideo(video)" title="Go to video analytics page on this video" >
            <b-icon icon="graph-up" />
            &nbsp;<span style="font-size:small">Video analytics</span>
          </b-btn>            
        </b-col>
      </b-row>

      <!-- Line separator between Analytics and Description--> 
      <div class="separatorCard"></div>

      <!-- Description section -->
      <b-row class="align-items-center mt-2 mb-2 ml-3 mr-1">
        <b-col cols="12 p-0" >
          <span v-if="video.description && video.description !== ''">
            <b-icon icon="file-earmark-text" />
            - {{video.description}}
          </span>
          <span v-else>
            <b-icon icon="file-earmark-text" />
            Description
          </span>
        </b-col>

      </b-row>

      <!-- Separator line between Description and Collections -->
      <div class="separatorCard"></div>

      <!-- Collections section -->
      <b-row class="align-items-center mt-2 mb-2 ml-3 mr-1">
        <span>
          <b-icon icon="collection"/>
          Collections
        </span>
      </b-row>

      <!-- If there are Collections, list of Collections -->
      <b-row v-if="video.collections && video.collections.length > 0" class="justify-content-around align-items-center mb-2">
        <div style="display: inline-block; margin: 0.25rem; font-size:12px" v-for="collection in video.collections" v-bind:key="collection">
          <div :class="{'collection-linked': (video.rulesFromCollection && video.rulesFromCollection === collection)}">
            <div :class="{'tag-not-selected': (selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1), 'tag-selected': selectedCollections.indexOf(collection) > -1, 'tag-excluded': exludedCollections.indexOf(collection) > -1 }" :title='collection'>
              <span @click="selectCollection(collection)">
                <b-icon v-if="selectedCollections.indexOf(collection) === -1" icon="collection" style="margin-right: 2px" />
                <b-iconstack v-if="selectedCollections.indexOf(collection) > -1" style="margin-right: 2px">
                  <b-icon stacked icon="collection" />
                  <b-icon stacked icon="check2" shift-h="2" shift-v="-1" scale="0.9" />
                </b-iconstack>
                {{collection}}
              </span>
            </div>
            <b-icon icon="graph-up" class="rounded iconStyle mb-1" font-scale="1.2" @click="$router.push('/analytics?video='+ video.videoID +'&collection=' + collection +'&config='+configurations.find(x => x.key === video.key).name+'&key=' + video.key + '&title=videoconfigcollection')" title="Show analytics for the video within this collection" /> 
          </div>
        </div>
      </b-row>

      <!-- Separator between Collections and Configs -->
      <div class="separatorCardDashed"></div>

      <!-- Configs section -->
      <b-row class="mt-2 mb-2 ml-3 mr-1">
        <p class="toolong mb-2 pt-1 pb-1" >
          <b-icon icon="gear-fill"/>
          Config: 
          <span class="tag-config pointerElt" v-if="video.key && (configurations.findIndex(x => x.key === video.key) > -1) && (video.client && video.client !== '')" @click="$router.push('/config?start=' + configurations.find(x => x.key === video.key).name)" :title="'Config used: '+configurations.find(x => x.key === video.key).name">
            <b-icon icon="gear-fill"/>
            {{configurations.find(x => x.key === video.key).name}}
          </span>
          <span v-else>
            <b-iconstack>
              <b-icon icon="play-fill" scale="0.7" shift-h="-1" shift-v="1" />
              <b-icon icon="search"/>
            </b-iconstack>
          </span>
        </p>
        <p class="toolong ml-3 mb-0" v-if="video.key && video.client && video.client !== ''" :title="'Key: '+video.key">                
          <b-icon icon="key" rotate="45"/>
          {{video.key}}
        </p>
      </b-row>

      <!-- Separator between Configs and Rules -->
      <!--<div class="separatorCardDashed"></div>-->

      <!-- Rules section -->
      <!--<b-row class="mt-2 mb-2 ml-3 mr-1">
        <span>
          <b-icon icon="sliders"/>
          {{$ml.get('confparam')}}
          <b-icon class="pointerC" v-b-popover.click.html="{title:$ml.get('paramsrules'), content:$ml.get('forconfigtobeapplied')}" style="margin-left:2px" icon="exclamation-circle" />
        </span>
      </b-row>-->

      <!-- Bound section into Rules -->
      <!--<b-row class="justify-content-center align-items-center" v-if="configurations.findIndex(x => x.key === video.key) > -1" >

        <span v-if="!video.rulesFromCollection && video.rules">
          <b-row class="customParamBadge m-1 justify-content-center align-items-center" >
            {{$ml.get('pluginvideobound3')}}&nbsp;
            <b-icon icon="cast" class="mr-1" />
            <strong>Custom</strong>
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPan')}}</p>
        </span>

        <span v-else-if="video.rulesFromCollection">
          <b-row class="collectionParamBadge m-1 justify-content-center align-items-center" >
            {{$ml.get('pluginvideobound2')}}&nbsp;
            <b-icon icon="collection" />
            <div class="toolong ml-1" style="max-width:175px; font-weight: bold">{{video.rulesFromCollection}}</div>
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPan')}}</p>
        </span>

        <span v-else-if="video.p2pConf && video.p2pConf.value != '' && video.p2pConf._timeElapsed < 300" >
          <b-row class="collectionParamBadge m-1 justify-content-center align-items-center" >
            {{$ml.get('pluginvideobound2')}}&nbsp; 
            <b-icon icon="collection" />
            <div class="toolong ml-1" style="max-width:175px; font-weight: bold">{{video.p2pConf.value}}</div>
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPlu')}}</p>              
        </span>

        <span v-else-if="!video.rules && !video.rulesFromCollection">
          <b-row class="configBadge m-1 justify-content-center align-items-center" >
            {{$ml.get('pluginvideobound')}}&nbsp; 
            <b-icon icon="gear-fill" />
            <div class="toolong ml-1" style="max-width:175px; font-weight: bold">{{configurations.find(x => x.key === video.key).name}}</div>
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPanDef')}}</p>
        </span>

      </b-row>-->

      <b-row class="justify-content-center mb-2">
        <b-button size="sm" variant="mswarning" @click = "search = video.videoID; isGetInProgress=true; onSearchBar(); selectedDis = 'all'">
          <b-icon scale="0.8" icon="arrows-fullscreen" />
          Full card
        </b-button>
      </b-row>

    </div>
  </b-row>

  <!-- Card of each Video -->
  <b-row class="marginB" v-if="selectedDisplay === 'mosaic' && selectedDis === 'all'">
    <div v-bind:class="{ 
      /*mycard2: (video.rebuff < 20 && !(video.error === true)),
      mycard: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
      mycard4: (video.rebuff >= 50 && !(video.error === true)),*/
      //A vérifier!
      mycardLiveOn: (runningVideos.findIndex(x => x.videoID === video.videoID && x.key === video.key) !== -1),
      mycard2: (runningVideos.findIndex(x => x.videoID === video.videoID && x.key === video.key) === -1),
      mycard5: ((video.dataDelivered === 0 || !video.hasOwnProperty('dataDelivered')) && runningVideos.findIndex(x => x.videoID === video.videoID && x.key === video.key) === -1),
      noDisplay: (isRunningOnly && runningVideos.findIndex(x => x.videoID === video.videoID && x.key === video.key) === -1)
    }" class='col-lg-3 col-md-4 col-sm-6 col-12 pr-0 pl-0 pb-2' style="font-size: small; color: #2a5d77" v-for="(video, idxVideo) in videos" v-bind:key="idxVideo">
      
      <!--Icon video + last 5min + Hidden -->
      <b-row class="align-items-center justify-content-between mt-1 ml-3 mr-1" >
        
        <div style="color: #ba0000" v-if="runningVideos.findIndex(x => x.videoID === video.videoID && x.key === video.key) !== -1">
          <b-icon icon="play-btn" scale="1.4" title="Active during the last 5min" />
          &nbsp;<small>{{$ml.get('activelast2min')}}</small>
        </div>
        <div v-if="runningVideos.findIndex(x => x.videoID === video.videoID && x.key === video.key) === -1">
          <b-icon icon="play-btn" scale="1.4" title="Inactive during the last 5min" />
        </div>

        <div style="text-align:right" v-if="video.isHidden">
          <span class="hiddenAuthBadge" style="padding:2px 10px; margin:0px; width:auto !important">
            <small>{{$ml.get('hidden')}}</small>
          </span>
        </div>
        <div style="text-align:right" v-else>
          <span class="hiddenAuthBadgeNone">
            <small>{{$ml.get('hidden')}}</small>
          </span>
        </div>

      </b-row>

      <!-- Title of the video-->
      <b-row class="ml-3 mr-3 mb-1 align-items-center justify-content-between" style="border-bottom: 1px solid #2F90B0">
        
        <h6 class="toolong" style="margin: 3px 0px; max-width: 94%" :title="'Title of the video: '+video.videoID+'. Corresponding to the analyticsVideoID or videoID mentionned in the configQuanteec object'">
          <strong v-if="activeSort === 'videoIDMin'" style="color:#14BF98">{{video.videoID}}</strong>
          <strong v-else >{{video.videoID}}</strong>
        </h6>

        <b-icon class="pointerEltSB" style="" icon="back" @click="$refs.copied.copyToClipboard(video.videoID);" title="Copy"/> 
        
      </b-row>

      <!-- Author (By) of the video -->
      <b-row class="ml-3 mr-1">
        <span class="toolong pb-3" style="color: #2a5d77" v-if="video.client && video.client !== ''">
          {{$ml.get('by')}}
          <strong> {{video.client}}</strong>
        </span>
      </b-row>

      <!-- Select button -->
      <div style="position: absolute; z-index: 3; margin-left: 3px">
        <b-form-checkbox v-model="video._isSelected" @input="updateSelectedNumber"></b-form-checkbox>
      </div>          

      <!-- Video thumbnail -->
      <b-row class="justify-content-center">
        <div @click="openAnalyticsForVideo(video)" class="previewContainer pointerC" style="z-index: 1; background-size: cover; background-repeat: no-repeat; background-image: url('Bg-Th.jpg') ">
          <!--
          <b-img @click="openAnalyticsForVideo(video)" v-if="video.isLive && !video.thumbnailURL"  class="previewImg" style="object-fit:contain; cursor:pointer" :src="require(`@/../public/Bg-Th.jpg`)" @error="imgUrlAlt($event, video)" fluid></b-img>
          <b-img @click="openAnalyticsForVideo(video)" v-if="!video.isLive && !video.thumbnailURL" class="previewImg" style="object-fit:contain; cursor:pointer" :src="require(`@/../public/Bg-Th.jpg`)" @error="imgUrlAlt($event, video)" fluid></b-img>
          <b-img @click="openAnalyticsForVideo(video)" v-if="video.thumbnailURL" class="previewImg" style="object-fit: contain; cursor: pointer" :src="video.thumbnailURL" @error="imgUrlAlt($event, video)" fluid></b-img>
          <div style="position:absolute; z-index:2; left: 5px; top: 3px">
            <b-form-checkbox v-model="video._isSelected" @input="updateSelectedNumber"></b-form-checkbox>
          </div>
          <h6 style="position: absolute; left: 50%; top: 8px">
            <b-badge variant="info">{{ idxVideo + 1 + (currentPage - 1) * numberPerPage}}</b-badge>
          </h6>-->
          <div style="color: white; position:absolute; z-index:2; left: 0px; top: 0px">
            <b-img v-if="video.stream_type === 'live'" style="width:70px" :src="require(`@/../public/live-icon.png`)" />
            <b-img v-if="video.stream_type === 'vod'" style="width:70px" :src="require(`@/../public/vod-icon.png`)" />
          </div>
          <div v-if="video.protocol && video.seg_ext" style="color: white; position:absolute; z-index:3; right: 5px; top: 5px">
            {{video.protocol}} ({{video.seg_ext}})
          </div>
          <b-row class="justify-content-center m-2 h6">
            <b-badge variant="info">{{ idxVideo + 1 + (currentPage - 1) * numberPerPage}}</b-badge>
          </b-row>
          <b-row class="justify-content-center m-3 h6">
            <span style="text-align: center; padding: 10px; border: 1px solid rgba(20, 191, 152, 0.3); color: rgba(255, 255, 255, 0.9); border-radius: 5px; background-color: rgba(255, 255, 255, 0.1)">
              <span v-if="activeSort === 'offload'">
                <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120 shrink-4" />
                {{video.offload_unit || '0 %'}}
              </span>
              <span v-if="activeSort === 'concurrentUsers'">
                <font-awesome-icon :icon="['fas', 'eye']" transform="shrink-4" /> 
                {{formatNbr(video.concurrentUsers) || '0'}}
              </span>
              <span v-if="activeSort === 'rebuff'">
                <font-awesome-icon :icon="['fas', 'spinner']" transform="shrink-4" />           
                {{video.rebuff || '0 %'}}
              </span>
              <span v-if="activeSort === 'dataDelivered'">
                <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4" />
                {{video.dataDelivered_unit || '0 MB'}}
              </span>
              <span v-if="activeSort === 'totalMB_peer'">
                <font-awesome-icon :icon="['fas', 'users']" transform="shrink-4" />
                {{video.totalMB_peer_unit || '0 MB'}}
              </span>
              <span v-if="activeSort === 'ttfb_total'">
                <b-icon scale="0.8" icon="clock-fill" />
                {{formatNbr(video.ttfb_total_unit) || '0 ms'}}
              </span>
              <span v-if="activeSort === 'createdDate'">
                <font-awesome-icon :icon="['fas', 'calendar-minus']" transform="shrink-4" />
                {{ video._created }}
              </span>
              <span v-if="activeSort === 'videoIDMin'">
                <b-icon icon="align-top" />
              </span>
              <span v-if="activeSort === 'energySaved'">
                <font-awesome-icon :icon="['fas', 'leaf']" transform="shrink-4" /> 
                {{video.energySaved_unit || '0 %'}}
              </span>
              <span v-if="activeSort === 'kwhSaved'">
                <font-awesome-icon :icon="['fas', 'plug']" style="color:#14BF98" transform="shrink-4" />
                {{video.kwhSaved_unit || '0 Wh'}}
              </span>
              <span v-if="activeSort === 'kwhSpent'">
                <font-awesome-icon :icon="['fas', 'plug']" transform="shrink-4" />
                {{video.kwhSpent_unit || '0 Wh'}}
              </span>

            </span>
          </b-row>

        </div>
      </b-row>

      <!-- Creation date -->
      <b-row class="justify-content-center m-1">
        <b-button size="sm" :variant="(activeSort === 'createdDate') ? 'greenwVLP':'transVLP'">
          <small style="font-size: 12px" title="Video creation date">
            <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
            {{ video._created }}
          </small>
        </b-button>
      </b-row>

      <!-- Separator between Creation date & Qualities -->
      <div class="separatorCard"></div>

      <!-- Qualities and Avg Bitrate section -->
      <b-row class="justify-content-center align-items-center mt-2 mb-0.5" style="" title="Only resolutions that have been viewed are shown here">
        {{$ml.get('qnbr')}}:
        {{video.q_nbr || 'N/A'}}
        - Res.:&nbsp;
        <b-badge class="mr-1" v-if="video.isSD" style="font-size:11px; background-color:#ba0000; padding:5px" title="SD res. viewed" >SD</b-badge>
        <b-badge class="mr-1" v-if="video.isHD" style="font-size:11px; background-color:#ba008f; padding:5px" title="HD res. viewed" >HD</b-badge>
        <b-badge class="mr-1" v-if="video.isFullHD" style="font-size:11px; background-color:#2F90B0; padding:5px" title="Full HD 1080p res viewed" >1080p</b-badge>
        <b-badge class="mr-1" v-if="video.is2K" style="font-size:11px; background-color:#aac8d4; padding:5px" title="2K 1440p res. viewed" >2K</b-badge>
        <b-badge class="mr-1" v-if="video.is4K" style="font-size:11px; background-color:rgb(20, 191, 152); padding:5px" title="4K 2160p res. viewed" >4K</b-badge>
        <small v-if="video.bestQualityPercent_unit">
          <font-awesome-icon :icon="['fas', 'signal']" />
          {{video.bestQualityPercent_unit}}
        </small>
      </b-row>

      <b-row class="justify-content-center align-items-center mt-2 mb-2" >
        <small>
          &#x7E;{{$ml.get('bitrate')}}: 
          {{video.bitrate_unit || '0 kbps'}}
        </small>
      </b-row>
      <b-row class="justify-content-around align-items-center mt-2 mb-2" >
        <small>
          {{$ml.get('segduration')}}:
          {{video.seg_dur || 'N/A'}}
        </small>
        <small>
          {{$ml.get('segnbr')}}:
          {{video.seg_nbr || 'N/A'}}
        </small>
      </b-row>
 
      <!-- Separator between Quality and Analytics sections -->
      <div class="separatorCard"></div>

      <!--1st line of Analytics -->
      <b-row class="justify-content-between align-items-center mt-1 mb-0.25 ml-3 mr-3">

        <b-button size="sm" :variant="(activeSort === 'concurrentUsers') ? 'greenwVLP':'transVLP'">
          <small title="Maximum concurrent viewers over the period">
            <font-awesome-icon :icon="['fas', 'eye']" />
            {{formatNbr(video.concurrentUsers) || '0'}}
          </small>
        </b-button>

        <b-button size="sm" style="margin-left:2px; margin-right:2px" :variant="(activeSort === 'rebuff') ? 'greenwVLP':'transVLP'">
          <small title="Rebuffering %" v-bind:class="{
            green: (video.rebuff < 2 && !(video.error === true)),
            orange: (video.rebuff >= 2 && video.rebuff < 5 && !(video.error === true)),
            red: (video.rebuff >= 5 && !(video.error === true)),
            black: (video.error === true || !video.hasOwnProperty('rebuff')),
            }"
          >
            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon> {{video.rebuff_unit || '0%'}}
          </small>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'ttfb_total') ? 'greenwVLP':'transVLP'">
          <small title="Time to First Byte">
            <b-icon scale="0.8" icon="clock-fill" />
            {{formatNbr(video.ttfb_total_unit) || '0 ms'}}
          </small>
        </b-button>

      </b-row>

      <!--2nd line of Analytics -->
      <b-row class="justify-content-between align-items-center mt-0.25 mb-0.25 ml-3 mr-3">
        <b-button size="sm" :variant="(activeSort === 'offload') ? 'greenwVLP':'transVLP'">
          <small title="Offload %">
            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120" />
            {{video.offload_unit || '0 %'}}
          </small>

        </b-button>
        <b-button size="sm" :variant="(activeSort === 'totalMB_peer') ? 'greenwVLP':'transVLP'">
          <small title="Data delivered by peers">
            <font-awesome-icon :icon="['fas', 'users']" />
            {{video.totalMB_peer_unit || '0 MB'}}
          </small>

        </b-button>
        <b-button size="sm" :variant="(activeSort === 'dataDelivered') ? 'greenwVLP':'transVLP'">
          <small title="Total data delivered">
            <font-awesome-icon :icon="['fas', 'database']" /> 
            {{video.dataDelivered_unit || '0 MB'}}
          </small>
        </b-button>
      </b-row>

      <!--3rd line of Analytics -->
      <b-row class="justify-content-between align-items-center mt-0.25 mb-2 ml-3 mr-3">
        <b-button size="sm" :variant="(activeSort === 'energySaved') ? 'greenwVLP':'transVLP'">
          <small title="Energy saved %">
            <font-awesome-icon :icon="['fas', 'leaf']" /> 
            {{video.energySaved_unit || '0 %'}}
          </small>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'kwhSaved') ? 'greenwVLP':'transVLP'">
          <small title="KWh saved">
            <font-awesome-icon :icon="['fas', 'plug']" style="color:#14BF98" />
            {{video.kwhSaved_unit || '0 Wh'}}
          </small>
        </b-button>

        <b-button size="sm" :variant="(activeSort === 'kwhSpent') ? 'greenwVLP':'transVLP'">
          <small title="KWh spent in total">
            <font-awesome-icon :icon="['fas', 'plug']" />
            {{video.kwhSpent_unit || '0 Wh'}}
          </small>
        </b-button>
      </b-row>

      <!-- Analytics button -->
      <b-row class="align-items-center justify-content-around mt-1 mb-2 ml-3 mr-3">
        <b-col cols="auto">
          <b-btn size="sm" variant="db-sb" @click="openAnalyticsForVideo(video)" title="Go to video analytics page on this video" >
            <b-icon icon="graph-up" />
            &nbsp;<span style="font-size:small">Video analytics</span>
          </b-btn>            
        </b-col>
      </b-row>

      <!-- Line separator between Analytics and Description--> 
      <div class="separatorCard"></div>

      <!-- Tags section (obsolete) -->
      <!--<b-row v-if="!video._modifyTags" class="pointerEltVideo" @click="startModifyTags(video)" title="Video tags, click to modify">
        <b-col cols="12">
          <p v-if="video.tags && video.tags !== ''" style="margin:0px">
            <small><font-awesome-layers>
              <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
              <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
            </font-awesome-layers>
            &nbsp;{{video.tags.split('|:|').join(' ')}}</small>
          </p>
          <p style="margin:0px" v-else>
            <small><font-awesome-layers>
              <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
              <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
            </font-awesome-layers> 
            &nbsp;-</small>
          </p>
        </b-col>
      </b-row>

      <b-row v-if="video._modifyTags" class="align-items-center" title="Video tags modification">
        <b-col cols="10">
          <tags-input style="font-size:85%" element-id="tags" 
          v-model="video._tags" @tags-updated="updateTags(video)" placeholder="Add a Tag, press Enter, then Validate"></tags-input>
        </b-col>
        <b-col cols="auto" style="padding:0px; margin-left:-10px">
          <b-button variant="emptyB" @click="endModifyTags(video)" type=submit>
            <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
          </b-button>
          <b-button variant="emptyB" @click="videos = videos.splice(0); video._modifyTags=false; cancelModifyTags(video)">
            <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
          </b-button>
        </b-col>
      </b-row>-->

      <!-- Description section -->
      <b-row class="align-items-center mt-2 mb-2 ml-3 mr-1">
        <b-col cols="12 p-0" v-if="!video._modifyDescription" class="pointerDescStyle" @click="video._modifyDescription = !video._modifyDescription; video._desc=video.description; videos=videos.splice(0)" title="Video description, click to modify">
          <span v-if="video.description && video.description !== ''">
            <b-icon icon="file-earmark-text" />
            - {{video.description}}
          </span>
          <span v-else>
            <b-icon icon="file-earmark-text" />
            Description
          </span>
        </b-col>

        <b-col cols="8 p-0" v-if="video._modifyDescription" title="Video description modification">
          <b-form @submit.prevent="updateDescription(video)">
            <b-form-textarea
            id="textarea"
            v-model="video._desc"
            placeholder="Write description here, then Validate"
            rows="1"
            max-rows="2"
            style="font-size:85%; margin: 5px 0px"
            ></b-form-textarea>
          </b-form>
        </b-col>
        <b-col cols="auto" v-if="video._modifyDescription" style="padding:0px;">
          <b-button variant="emptyB" @click="updateDescription(video);">
            <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
          </b-button>
          <b-button variant="emptyB" @click="video._modifyDescription = false; video._desc=video.description; videos = videos.splice(0)">
            <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
          </b-button>
        </b-col>

      </b-row>

      <!-- Separator line between Description and Collections -->
      <div class="separatorCard"></div>

      <!-- Collections section -->
      <b-row class="align-items-center mt-2 mb-2 ml-3 mr-1">
        <span>
          <b-icon icon="collection"/>
          Collections
        </span>
      </b-row>

      <!-- If there are Collections, list of Collections -->
      <b-row v-if="video.collections && video.collections.length > 0" class="justify-content-around align-items-center">
        <div style="display: inline-block; margin: 0.25rem; font-size:12px" v-for="collection in video.collections" v-bind:key="collection">
          <div :class="{'collection-linked': (video.rulesFromCollection && video.rulesFromCollection === collection)}">
            <div :class="{'tag-not-selected': (selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1), 'tag-selected': selectedCollections.indexOf(collection) > -1, 'tag-excluded': exludedCollections.indexOf(collection) > -1 }" :title='collection'>
              <span @click="selectCollection(collection)">
                <b-icon v-if="selectedCollections.indexOf(collection) === -1" icon="collection" style="margin-right: 2px" />
                <b-iconstack v-if="selectedCollections.indexOf(collection) > -1" style="margin-right: 2px">
                  <b-icon stacked icon="collection" />
                  <b-icon stacked icon="check2" shift-h="2" shift-v="-1" scale="0.9" />
                </b-iconstack>
                {{collection}}
              </span>
            </div>
            <b-icon icon="graph-up" class="rounded iconStyle mb-1" font-scale="1.2" @click="$router.push('/analytics?video='+ video.videoID +'&collection=' + collection +'&config='+configurations.find(x => x.key === video.key).name+'&key=' + video.key + '&title=videoconfigcollection')" title="Show analytics for the video within this collection" /> 
            <b-icon icon="x" class="rounded-circle iconStyleR mb-1" font-scale="1.2" @click="selectedCollection = collection; selectedVideo = video; showModal('removelocalcollection')" title="Remove Collection from video" />
          </div>
        </div>
      </b-row>

      <!-- Link to Collection button -->
      <b-row class="justify-content-center align-items-center marginalsm">
        <b-badge pill class="linkBadge pb-1 pt-1" @click="selectedVideo = video; showModal('linkcollection')">
          <b-icon icon="plus" scale="1.7"/>
          &nbsp;<span style="font-size:small">{{$ml.get('linknewcollection')}}</span>
        </b-badge>
      </b-row>

      <!-- Separator between Collections and Configs -->
      <div class="separatorCardDashed"></div>

      <!-- Configs section -->
      <b-row v-if="video.key" class="mt-2 mb-2 ml-3 mr-1">
        <p class="toolong mb-2 pt-1 pb-1" >
          <b-icon icon="gear-fill"/>
          Config: 
          <span class="tag-config pointerElt" v-if="(configurations.findIndex(x => x.key === video.key) > -1) && (video.client && video.client !== '')" @click="$router.push('/config?start=' + configurations.find(x => x.key === video.key).name)" :title="'Config used: '+configurations.find(x => x.key === video.key).name">
            <b-icon icon="gear-fill"/>
            {{configurations.find(x => x.key === video.key).name}}
          </span>
        </p>
        <p class="toolong ml-3 mb-0" v-if="video.client && video.client !== ''" :title="'Key: '+video.key">                
          <b-icon icon="key" rotate="45"/>
          {{video.key}}
        </p>
      </b-row>

      <!-- Separator between Configs and Rules -->
      <div class="separatorCardDashed"></div>

      <!-- Rules section -->
      <b-row class="mt-2 mb-2 ml-3 mr-1">
        <span>
          <b-icon icon="sliders"/>
          {{$ml.get('confparam')}}
          <b-icon class="pointerC" v-b-popover.click.html="{title:$ml.get('paramsrules'), content:$ml.get('forconfigtobeapplied')}" style="margin-left:2px" icon="exclamation-circle" />
        </span>
      </b-row>

      <!-- Bound section into Rules -->
      <b-row class="justify-content-center align-items-center" v-if="configurations.findIndex(x => x.key === video.key) > -1" >

        <span v-if="!video.rulesFromCollection && video.rules">
          <b-row class="customParamBadge m-1 justify-content-center align-items-center" @click="selectedVideo = video; showModal('authorizations')" title="See Custom Params" >
            {{$ml.get('pluginvideobound3')}}&nbsp;
            <b-icon icon="cast" class="mr-1" />
            <strong>Custom</strong>
            <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleC" v-if="video._initRuleSelected === 'custom'" />
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPan')}}</p>
        </span>

        <span v-else-if="video.rulesFromCollection">
          <b-row class="collectionParamBadge m-1 justify-content-center align-items-center" @click="selectedVideo = video; showModal('authorizationsRO')" title="See Collection Params" >
            {{$ml.get('pluginvideobound2')}}&nbsp;
            <b-icon icon="collection" />
            <div class="toolong ml-1" style="max-width:175px; font-weight: bold">{{video.rulesFromCollection}}</div>
            <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleCol" v-if="video._initRuleSelected !== 'custom' && video._initRuleSelected !== 'configuration'" />
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPan')}}</p>
        </span>

        <span v-else-if="video.p2pConf && video.p2pConf.value != '' && video.p2pConf._timeElapsed < 300" >
          <b-row class="collectionParamBadge m-1 justify-content-center align-items-center" @click="collectionAuth = collections.find(x=>x.name === video.p2pConf.value); showModal('authorizationsCollectionRO')" title="See Collection Params" >
            {{$ml.get('pluginvideobound2')}}&nbsp; 
            <b-icon icon="collection" />
            <div class="toolong ml-1" style="max-width:175px; font-weight: bold">{{video.p2pConf.value}}</div>
            <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleCol" />
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPlu')}}</p>              
        </span>

        <span v-else-if="!video.rules && !video.rulesFromCollection">
          <b-row class="configBadge m-1 justify-content-center align-items-center" @click="$router.push('/config?start=' + configurations.find(x => x.key === video.key).name)" title="See Config params" >
            {{$ml.get('pluginvideobound')}}&nbsp; 
            <b-icon icon="gear-fill" />
            <div class="toolong ml-1" style="max-width:175px; font-weight: bold">{{configurations.find(x => x.key === video.key).name}}</div>
            <b-icon icon="sliders" font-scale="1.2" class="ml-1 rounded iconStyleConf" v-if="video._initRuleSelected === 'configuration'" />
          </b-row>
          <p style="font-size:x-small; text-align:center">{{$ml.get('setfromPanDef')}}</p>
        </span>

      </b-row>

      <!-- Modify Bounded Rules -->
      <b-row class="justify-content-center align-items-center mb-2" title="Modify Rules Bound" v-if="video._ruleSelected === video._initRuleSelected">
        {{$ml.get('modify')}}:
        <b-form-group class="m-1" label-cols="auto" label-size="sm" :label-for="'parametersSelect' + idxVideo">
          <b-form-select size="sm" style="font-size:13px" :id="'parametersSelect' + idxVideo" v-model="video._ruleSelected" :options="video._options" @change="inputParametersSelected(video)" :disabled="!authorized"></b-form-select>
        </b-form-group>
      </b-row>

      <!--
      <b-row class="justify-content-center align-items-center mb-2" title="Modify Rules Bound" v-else>
        <b-col cols="8" class="p-0" style="text-align:center">
          <b-form-group class="m-0" label-cols="auto" label-size="sm" :label-for="'parametersSelect' + idxVideo">
            <b-form-select size="sm" style="font-size:13px" :id="'parametersSelect' + idxVideo" v-model="video._ruleSelected" :options="video._options" @change="inputParametersSelected(video)" :disabled="!authorized"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="4" class="p-0" style="text-align:center">
          <b-btn size="sm" variant="emptyB" @click="updateRuleSelected(video)" :disabled="!authorized">
            <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
          </b-btn>
          <b-btn size="sm" variant="emptyB" @click="video._ruleSelected = video._initRuleSelected;videos=videos.splice(0)" :disabled="!authorized">
            <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
          </b-btn>
        </b-col>
      </b-row>
      -->

      <!-- Message of Current Rule applied (obsolete) -->
      <!--
      <p style="margin-bottom:15px; text-align:center; font-size:small;" >
          {{$ml.get("currentrule")}}
          <span v-if="video._ruleSelected === 'custom'"><strong>custom</strong></span> 
          <span v-if="video._ruleSelected !== 'custom' && video._ruleSelected !== 'configuration'">[Collection] <strong>{{video.rulesFromCollection}}</strong></span>
          <span v-if="video._ruleSelected === 'configuration' && video.p2pConf && video.p2pConf.value != '' && video.p2pConf._timeElapsed < 300">[Collection] <strong>{{video.p2pConf.value}}</strong></span>
          <span v-if="video._ruleSelected === 'configuration' && configurations && configurations.length > 0 && configurations.find(x => x.key === video.key) && (!video.p2pConf || video.p2pConf.value === '' || video.p2pConf._timeElapsed >= 300)">[Config] <strong>{{configurations.find(x => x.key === video.key).name}}</strong></span>
          <span v-if="video._ruleSelected === 'configuration' && (!configurations || configurations.length === 0 || !configurations.find(x => x.key === video.key)) && (!video.p2pConf || video.p2pConf.value === '' || video.p2pConf._timeElapsed >= 300)">[Config] <strong>default</strong></span>
      </p>
      <p style="margin-bottom:15px; margin-left:4px; font-size:x-small;" v-if="video._ruleSelected === 'configuration' && (!video.p2pConf || video.p2pConf.value === '' || video.p2pConf._timeElapsed >= 300)">
          {{$ml.get("forconfigtobeapplied")}}
      </p>
      -->

      <!-- If Rule received from SDK, message -->
      <div v-if="video.p2pConf && video.p2pConf.value">
        <!-- Separator between Modify and Mesg for Rule from SDK-->

        <div class="separatorCardBottom ml-3 mr-3"></div>

        <!-- Message for Rule received from SDK -->
        <b-row class="justify-content-center mt-2 mb-4 align-items-center">
          <b-col cols="12 m-1" style="text-align: center;font-size:small; color: #2a5d77;">
            {{$ml.get('lastcollectionsdk')}} <strong>{{video.p2pConf.value}}</strong>
          </b-col>
          <b-col cols="12 m-1" style="text-align: center;font-size:small; color: #2a5d77;">
            {{$ml.get('on')}} <strong>{{video.p2pConf._latestDate}}</strong>
          </b-col>
        </b-row>
      </div>

    </div> <!-- End Card for each Video -->
  </b-row> <!-- End b-row of each Card -->

  <b-button v-if="selectedDis === '20'" class="m-1" size="sm" :variant="(selectedDis === '50' ) ? 'greenw':'darkblue'" @click="activateTop(50); saveDisplayParameters()" title="Go to Top 50">
    {{$ml.get('add')}}
    <b-badge pill variant="danger">30</b-badge>
  </b-button>
  <b-button v-if="selectedDis === '50'" class="m-1" size="sm" :variant="(selectedDis === '50' ) ? 'greenw':'darkblue'" @click="activateTop(20); saveDisplayParameters()" title="Go back to Top 20">
    {{$ml.get('remove')}}
    <b-badge pill variant="danger">30</b-badge>
  </b-button>

</b-container>

  <b-pagination 
    style="margin-top:2rem"
    size="sm"
    class="small"
    v-if="videos.length !== undefined && realTotalNumberOfPage > 1 && selectedDis === 'all'"
    align="center" 
    :limit="8" 
    :total-rows="realTotalNumberOfPage" 
    v-model="currentPage" 
    :per-page="1" 
    first-number last-number 
    @input="getVideos()">
  </b-pagination>

  <b-row v-if="selectedDis === 'all' && realTotalNumberOfPage > 10 && videos.length !== undefined" class="justify-content-center small" style="margin-right:0px">
    <b-col cols="10" xs="8" md="8" lg="3">
      <b-form @submit.prevent="currentPage = goPage">
        <b-form-group >
          <b-input-group size="sm" prepend="Go to page:">
            <b-form-input type="number" min="1" v-model="goPage"></b-form-input>
            <b-input-group-append><b-button variant="db-sb" @click="currentPage = goPage">Go</b-button></b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>

  <a id="bottom"></a>

  <b-modal 
    id="authorizations"
    ref="authorizations"
    :title="$ml.get('customconf')"
    size="lg"
    hide-footer
  >
   <b-card border-variant="msstream" size="sm" no-body style="font-size:small; margin-top:0px; margin-bottom:20px">
     <b-card-body>
      <ConfigParamForm :video="selectedVideo" type="video" @closeModal="onCloseModal($event, 'authorizations')"></ConfigParamForm>
    </b-card-body>
   </b-card>
  </b-modal>

  <b-modal 
    id="authorizationsRO"
    ref="authorizationsRO"
    :title="$ml.get('collectconf')"
    size="lg"
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
     <b-card-body>
      <ConfigParamForm :video="selectedVideo" type="video" :readonly="true" @closeModal="onCloseModal($event, 'authorizationsRO')"></ConfigParamForm>
    </b-card-body>
   </b-card>
  </b-modal>

  <b-modal 
    id="removeglobalcollection"
    ref="removeglobalcollection"
    :title="$ml.get('deletecollect')"
    size="md"
    hide-footer
  >
   <p style="font-size:small" v-html="$ml.get('areyousurecollection')"></p>
   <hr />
   <b-row class="justify-content-center mt-4">
    <b-col cols="auto">
      <b-button size="sm" variant="msstreamblue" @click="removeCollection(selectedCollection);hideModal('removeglobalcollection')">
        <b-icon icon="check2-square"/> 
        {{$ml.get("confirm")}}
      </b-button>
    </b-col>
   </b-row>
  </b-modal>

  <b-modal 
    id="removemultipleglobalcollection"
    ref="removemultipleglobalcollection"
    title="Delete selected Collections"
    size="md"
    hide-footer
  >
   <p style="font-size:small" v-html="$ml.get('areyousurecollections')"></p>
   <hr />  
   <b-row class="justify-content-center mt-4">
    <b-col cols="auto">
      <b-button size="sm" variant="msstreamblue" @click="removeMultipleCollection(selectedCollections);hideModal('removemultipleglobalcollection')">
        <b-icon icon="check2-square"/> 
        {{$ml.get("confirm")}}
      </b-button>
    </b-col>
   </b-row>
  </b-modal>

  <b-modal 
    id="removelocalcollection"
    ref="removelocalcollection"
    :title="$ml.get('unlinkcollect')"
    size="md"
    hide-footer
  >
   <p style="font-size:small" v-html="$ml.get('areyousurelinkcollection')"></p>
   <hr />
   <b-row class="justify-content-center mt-4">
    <b-col cols="auto">
      <b-button size="sm" variant="msstreamblue" @click="removeCollectionFromVideo(selectedVideo, selectedCollection);hideModal('removelocalcollection')">
        <b-icon icon="check2-square"/> 
        {{$ml.get("confirm")}}
      </b-button>
    </b-col>
   </b-row>
  </b-modal>

  <b-modal 
    id="newcollection"
    ref="newcollection"
    :title="$ml.get('addcollect')"
    size="md"
    hide-footer
  >
    <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
      <b-card-body>
        <new-collection @closeModal="getCollections();onCloseModal($event, 'newcollection')"></new-collection>
      </b-card-body>
    </b-card>
  </b-modal>

  <b-modal 
    id="linkcollection"
    ref="linkcollection"
    :title="$ml.get('linkcollect')"
    size="md"
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
     <b-card-body>
      <link-collection :video="selectedVideo" :collections="collections" @closeModal="getVideos();onCloseModal($event,'linkcollection')"></link-collection>
    </b-card-body>
   </b-card>
  </b-modal>

  <b-modal 
    id="authorizationsCollection"
    ref="authorizationsCollection"
    :title="$ml.get('collectconf')"
    size="lg"
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
     <b-card-body>
      <ConfigParamForm :collection="collectionAuth" type="collection" @closeModal="onCloseModal($event, 'authorizationsCollection')"></ConfigParamForm>
    </b-card-body>
   </b-card>
  </b-modal>

  <b-modal 
    id="authorizationsCollectionRO"
    ref="authorizationsCollectionRO"
    :title="$ml.get('collectconf')"
    size="lg"
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
     <b-card-body>
      <ConfigParamForm :collection="collectionAuth" type="collection" :readonly="true" @closeModal="onCloseModal($event, 'authorizationsCollectionRO')"></ConfigParamForm>
    </b-card-body>
   </b-card>
  </b-modal>


  <b-modal
    id="modifyThumbnail"
    ref="modifyThumbnail"
    :title="$ml.get('thumbmod')"
    @show="openModalThumbnail"
    size="md"
  >
  </b-modal>

<CopiedModal ref="copied"></CopiedModal>

</div>
</template>

<script>
import ConfigParamForm from '@/components/ConfigParamForm';
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import VideoService from "@/services/video.service";
import CollectionService from "@/services/collection.service";
import ConfigurationService from "@/services/configuration.service";
import AnalyticsService from "@/services/analytics.service";
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import PluginParamsService from "@/services/videoPluginParams.service.js"
var videoService = new VideoService();
var collectionService = new CollectionService();
var configurationService = new ConfigurationService();
var analyticsService = new AnalyticsService();
var pluginParamsService = new PluginParamsService();

import {v4 as uuidv4} from 'uuid';
import ConfigParamFormVue from './ConfigParamForm.vue';
import NewCollection from './NewCollection.vue';
import LinkCollection from './LinkCollection.vue';
import CopiedModal from '@/components/modals/CopiedModal.vue';

let myDateBegin = new Date();
let moment = require("moment");

export default {
  name: "VideoListPlugin",
  components: {
    FadeLoader,
    ConfigParamForm,
    NewCollection,
    CopiedModal,
    LinkCollection,
    DatePicker
  },
  data: function () {
    return {
      showDetailsRow: false,
      dateLabel: '1d',
      dateLabeldef: 'null',
      defaultdate: moment(new Date(myDateBegin.getFullYear(), myDateBegin.getMonth(), myDateBegin.getDate() -1, 0, 0, 0)).format("DD/MM/YY"),

      dateLabelOptions: [
        {text:'Last hour', value: '1h'},
        {text:'Last 3 hours', value: '3h'},
        {text:'Last 6 hours', value: '6h'},
        {text:'Last 12 hours', value: '12h'},
        {text:'Last 24 hours', value: '1d'},
        {text:'Last 2 days', value: '2d'},
        {text:'Last 7 days', value: '7d'},
        {text:'Last 14 days', value: '14d'},
        {text:'Last 30 days', value: '30d'},
        {text:'Custom', value: 'custom'}
      ],

      topsTable:  [
        { key: "index", label: "#", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "videoID", label: "Title", sortable: false, thClass: 'text-center', tdClass: 'align-middle', thStyle: 'width:55%' },
        { key: "concurrentUsers", label: "Max. viewers", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "rebuff", label: "Rebuff. %", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "offload_unit", label: "Offload %", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        /*        
        { key: "totalMB_peer_unit", label: "P2P data", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "dataDelivered_unit", label: "Total data", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        */
        { key: "actions", label: "Analytics", thClass: 'text-center', tdClass: 'align-middle' }
      ],

      videosTable:  [
        { key: "index", label: "#", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "videoID", label: "Title", sortable: false, thClass: 'text-center', tdClass: 'align-middle', thStyle: 'width:55%' },
        { key: "concurrentUsers", label: "Max. viewers", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "rebuff", label: "Rebuff. %", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "ttfb_total_unit", label: "TTFB", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "offload_unit", label: "Offload %", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "energySaved_unit", label: "Energy %", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        /*
        { key: "totalMB_peer_unit", label: "P2P data", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "dataDelivered_unit", label: "Total data", sortable: false, thClass: 'text-center', tdClass: 'align-middle' },
        */
        { key: "actions", label: "Analytics", thClass: 'text-center', tdClass: 'align-middle' }
      ],

      activeSortTable: [
        { key: "videoIDMin", text: "Title", value: 'videoIDMin' },
        { key: "createdDate", text: "Creation date", value: 'createdDate' },
        { key: "concurrentUsers", text: "Max. viewers", value: 'concurrentUsers' },
        { key: "rebuff", text: "Rebuff. %", value: 'rebuff' },
        { key: "ttfb_total", text: "TTFB", value: 'ttfb_total' },
        { key: "offload", text: "Offload %", value: 'offload' },
        { key: "totalMB_peer", text: "P2P data", value: 'totalMB_peer' },
        { key: "dataDelivered", text: "Total data", value: 'dataDelivered' },
        { key: "energySaved", text: "Energy saved %", value: 'energySaved' },
        { key: "kwhSaved", text: "kWh saved", value: 'kwhSaved' },
        { key: "kwhSpent", text: "kWh spent", value: 'kwhSpent' },
      ],

      topSortTable: [
        { key: "concurrentUsers", text: "Max. viewers", value: 'concurrentUsers' },
        { key: "rebuff", text: "Rebuff. %", value: 'rebuff' },
        { key: "offload", text: "Offload %", value: 'offload' },
        { key: "totalMB_peer", text: "P2P data", value: 'totalMB_peer' },
        { key: "dataDelivered", text: "Total data", value: 'dataDelivered' },
      ],

      sortBy:"video_id",
      sortOn:"concurrentUsers",
      startDate:"now-1d",
      endDate:"now",
      rankingTable:[],
      rankSize: 20,
      selectedDisplay: "mosaic",
      selectedDis: 'all',

      dateStart: '',
      dateEnd: '',
      range: {
          end: new Date(),
          start: new Date(myDateBegin.getFullYear(), myDateBegin.getMonth(), myDateBegin.getDate(), myDateBegin.getHours() - 24, 0, 0),
          dispEnd: '1',
          dispStart: '1',
      },
      calendarValidate: false, 

      authorized: this.$auth.validateRoles(['modifyVideos']),
      authorizedRead: this.$auth.validateRoles(['readVideos']),
      configurations: [],
      configurationsOptions: [],
      videos: [],
      videosRun: [],
      runningVideos: [],
      isRunningOnly: false,
      clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,

      //PAGE
      totalNumberOfPage: 1000000,
      realTotalNumberOfPage: 1000000,
      currentPage: 1,
      currentPageRun: 1,
      goPage: 1,
      numberPerPage: (this.$auth.getMyUser().client_infos && this.$auth.getMyUser().client_infos[0] && this.$auth.getMyUser().client_infos[0].defaultNumberPerPage) ? this.$auth.getMyUser().client_infos[0].defaultNumberPerPage : 20,
      lastGetWithPage: false,

      //SEARCH PARAM
      search: "",
      searchParameters: {},
      searchCollection: "",

      // LOADER
      isGetInProgress: false,
      isGetTopInProgress: false,
      timeoutSearch: null,
      timeoutSearchDuration: 2,

      // Advanced Filter :
      advancedFilter: false,
      showFilterC: false,
      showFilterT: false,

      oldAdvancedFilters: 'livevod',
      advancedFiltersDefault: ['live', 'vod'],
      advancedFilters: ['live', 'vod'],
      advancedFilterOptions: [
        { text: 'Live', value: 'live' },
        { text: 'VOD', value: 'vod' },
        /*{ text: 'Live archive', value: 'archive' },
        { text: 'Cut', value: 'cut' }*/
      ],

      qualityFiltersDefault:['isSD','isHD','isFullHD','is2K','is4K','is8K'],
      qualityFilters:['isSD','isHD','isFullHD','is2K','is4K','is8K'],
      qualityFilterOptions: [
        { text: 'SD', value: 'isSD' },
        { text: 'HD', value: 'isHD' },
        { text: 'FullHD', value: 'isFullHD' },
        { text: '2K', value: 'is2K' },
        { text: '4K', value: 'is4K' },
        { text: '8K', value: 'is8K' },
      ],

      oldQualityFilters:'isSDisHDisFullHDis2Kis4Kis8K',

      protFiltersDefault: ['hls','dash'],
      protFilters: ['hls','dash'],
      advancedProtOptions: [
        { text: 'HLS', value: 'hls' },
        { text: 'DASH', value: 'dash' },
      ],

      segFiltersDefault: ['ts','mp4'],
      segFilters: ['ts','mp4'],
      advancedSegOptions: [
        { text: '.ts', value: 'ts' },
        { text: '.mp4', value: 'mp4' },
      ],

      barOrCheck: false,

      //STAT
      numberOfVideos: 0,
      numberOfVideosRun: 0,

      totalNumberOfVideos: 0,
      liveNumber: 0,
      vodNumber: 0,

      activeSort: "concurrentUsers",
      activeSortOrder: -1,
      mySort: JSON.stringify({ concurrentUsers: -1 }),

      /*
      authorizedStream:false,
      authorizedVPNs:false,
      authorizedIPs : [],
      unauthorizedIPs : [],
      authorizedCountries : [],
      unauthorizedCountries : [],
      whitelistedWebsite : [],
      blacklistedWebsite : [],
      authorizedVPNsList : [],
      ICEConfig : "QUANTEEC",
      */
      authIPaddr:"isAuthorizedIPs",
      authCountries: '1',
      authWebsites: '1',

      selectedVideo : {
        thumbnailURL:"",
        authorizedIPs:[],        
        unauthorizedIPs:[],
        authorizedSubdomains : [],
        unauthorizedSubdomains : [],
        authorizedCountries:[],
        unauthorizedCountries:[],
        whitelistedWebsite:[],
        blacklistedWebsite:[],
        authorizedVPNsList:[],
        _authorizedVPNsList:[],
        _authorizedIPs:[],
        _authorizedIPsTags: [],
        _unauthorizedIPs:[],
        _unauthorizedIPsTags:[],
        _authorizedSubdomains : [],
        _authorizedSubdomainsTags : [],
        _unauthorizedSubdomains : [],
        _unauthorizedSubdomainsTags : [],
        _authorizedCountries:[],
        _unauthorizedCountries:[],
        _whitelistedWebsite:[],
        _blacklistedWebsite:[],
      },
      authorizedVPNs:false,
      authorizedStream:false,
      isAuthorizedIPs:"IPAuthorized",
      isAuthorizedSubdomains:"SubdomainAuthorized",
      isAuthorizedCountries:"countriesAuthorized",
      isAuthorizedWebsites:"websitesAuthorized",
      ICEConfig:"QUANTEEC",
      customIce: [],
      collectionAuth: {

      },

      defaultParams:null,

      modifyAuthorizedIPs:false,
      modifyUnauthorizedIPs:false,
      modifyAuthorizedSubdomains:false,
      modifyUnauthorizedSubdomains:false,
      modifyAuthorizedCountries:false,
      modifyUnauthorizedCountries:false,
      modifyWhitelistedWebsites:false,
      modifyBlacklistedWebsites:false,
      modifyAuthorizedVPNs:false,

      isSelectAll:false,
      nbrVideoSelected:0,
/*
      interVidRun:0,
      nbHidden:0,
*/
      seeHidden:false,
      seeOnlyHidden:false,
      totalNumberVideoHidden: 0,
      collections: [],
      clientCollections:[],
      clientCollectionsComplete:[],
      selectedCollections:[],
      selectedCollection:"",
      exludedCollections:[],
      selectedKey:"",
      ss:"",
    }
  },
      
  mounted: function () {
    let storageSearchInfos = this.getSearchParameters();
    let displayInfos = this.getDisplayParameters();
    let storageSort = this.getSortParameters();
    let showActive = this.getShowActive(); 
    let showHidden = this.getSeeHidden();
    let showFilterC = this.getShowCol();
    let showFilterT = this.getShowFil();
    let showDetailsRow = this.getShowDetailsRow();

    this.searchParameters = storageSearchInfos.searchParameters || this.searchParameters;
    this.search = storageSearchInfos.searchBar || this.search;
    this.qualityFilters = storageSearchInfos.qualityFilters || this.qualityFilters;
    this.advancedFilters = storageSearchInfos.advancedFilters || this.advancedFilters;
    this.protFilters = storageSearchInfos.protFilters || this.protFilters;
    this.segFilters = storageSearchInfos.segFilters || this.segFilters;

    if (showDetailsRow.showDetailsRow === "true")
      this.showDetailsRow = true;
    else
      this.showDetailsRow = false;

    if (showFilterC.showFilterC === "true")
      this.showFilterC = true;
    else
      this.showFilterC = false;

    if (showFilterT.showFilterT === "true")
      this.showFilterT = true;
    else
      this.showFilterT = false;
      
    if (showActive.isRunningOnly === "true")
      this.isRunningOnly = true;
    else
      this.isRunningOnly = false;

    if (showHidden.seeHidden === "true")
      this.seeHidden = true;
    else
      this.seeHidden = false;

    this.activeSort = storageSort.sort || this.activeSort;
    
    if (this.activeSort === "offload" || this.activeSort === "concurrentUsers" || this.activeSort === "rebuff" || this.activeSort === "dataDelivered" || this.activeSort === "totalMB_peer")
      this.sortOn = this.activeSort;

    this.selectedDisplay = displayInfos.selectedDisplay || this.selectedDisplay;
    this.selectedDis = displayInfos.selectedDis || this.selectedDis;
    this.sortOn = displayInfos.sortOn || this.sortOn;
    this.range = displayInfos.range || this.range;

    this.dateLabel = displayInfos.dateLabel || this.dateLabel;

    this.activeSortOrder =
      storageSort.sortOrder !== null && storageSort.sortOrder !== undefined
        ? storageSort.sortOrder
        : this.activeSortOrder;
    this.mySort = JSON.stringify({ [this.activeSort]: this.activeSortOrder });
    this.selectedKey = storageSearchInfos.searchKey;
    if (this.selectedKey !== "") {
      this.advancedFilter = true;
    }
    if(storageSearchInfos.searchParameters && storageSearchInfos.searchParameters['$and'])
    {
      storageSearchInfos.searchParameters["$and"].forEach(param=>{
        if(Object.keys(param)[0] === "collections")
        {
          if(param.collections["$in"])
          {
            
            this.selectedCollections = param.collections["$in"]
          }

          if(param.collections["$nin"])
          {
            this.exludedCollections = param.collections["$nin"]
          }
        }
      })
    }

    this.getVideos(this.currentPage);
    this.getCollections().then(()=>{
      this.selectedCollections.forEach(collection=>{
        let currentCollection = document.getElementById("tag-"+collection)
        if(currentCollection){
        currentCollection.classList.add('tag-selected');
        currentCollection.classList.remove('tag-not-selected');
        }
      })

      this.exludedCollections.forEach(collection=>{
        let currentCollection = document.getElementById("tag-"+collection)
        if(currentCollection){
        currentCollection.classList.add('tag-excluded');
        currentCollection.classList.remove('tag-not-selected');
        }
      })
    }).catch(err => {})

    this.getConfigs();

  },
  computed:{
    defaultAdvancedFilters() {
      function areEqual(array1, array2) {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }
            return false;
          });
        }
        return false;
      }
      return areEqual(this.advancedFilters, this.advancedFiltersDefault);
    },
    defaultQFilters() {
      function areEqual(array1, array2) {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }
            return false;
          });
        }
        return false;
      }
      return areEqual(this.qualityFilters, this.qualityFiltersDefault);
    },
    defaultProtFilters() {
      function areEqual(array1, array2) {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }
            return false;
          });
        }
        return false;
      }
      return areEqual(this.protFilters, this.protFiltersDefault);
    },
    defaultSegFilters() {
      function areEqual(array1, array2) {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }
            return false;
          });
        }
        return false;
      }
      return areEqual(this.segFilters, this.segFiltersDefault);
    },

  },
  methods : {
    updateTop()
    {
      this.adjustDate();
      let sortOn = "";
      sortOn = this.mapSortTop();
      this.isGetTopInProgress = true;
      analyticsService.getTop10(this.clientView, this.sortBy, sortOn, this.startDate, this.endDate, this.rankSize, this.$auth.token()).then(response=>{
        this.rankingTable = [];
        response.forEach((element, index) => {
          let local_ttfb = "0 ms"
          try {
            local_ttfb = (element.ttfb_peer.value == null) ? Math.round(element.ttfb_server.value) + " ms" : Math.round((element.offload_percent.value / 100 * element.ttfb_peer.value + (100 - element.offload_percent.value)/100 * element.ttfb_server.value) / 2).toString() + " ms"
          } catch(err) {

          }
          let object = {
            videoID: element.videoID,
            concurrentUsers: element.max_viewers.value,
            bitrate_unit: (element.sec_peer.value + element.sec_server.value > 0) ? this.displayBitrate(Math.round((8 * (element.MB_peer.value + element.MB_server.value)) / (element.sec_peer.value + element.sec_server.value))) : "0 kbps",
            offload_unit: Number(element.offload_percent.value).toFixed(0) + " %",
            totalMB_peer_unit: this.display_MB(element.MB_peer.value),
            ttfb_total_unit: local_ttfb,
            data_downloaded_from_CDN: this.display_MB(element.MB_server.value),
            dataDelivered_unit: this.display_MB(element.MB_total.value),
            rebuff: Number(element.rebuf.value).toFixed(2) + " %",
            collections: (element.video)?element.video.collections: [],
            _created: (element.video)?moment(element.video.createdDate).format("DD/MM/YY @HH:mm"): '',
            key: (element.video)?element.video.key: '',
            client: (element.video)?element.video.client: '',
            stream_type: (element.video)?element.video.stream_type: '', 
            protocol: (element.video)?element.video.protocol: '',
            seg_ext: (element.video)?element.video.seg_ext: '',
            seg_dur: (element.video)?element.video.seg_dur: '',
            seg_nbr: (element.video)?element.video.seg_nbr: '',
            q_nbr: (element.video)?element.video.q_nbr: '',
            isHidden: (element.video)?element.video.isHidden: '',
            description: (element.video)?element.video.description: '',
            isSD: (element.video)?element.video.isSD: '',
            isHD: (element.video)?element.video.isHD: '',
            isFullHD: (element.video)?element.video.isFullHD: '',
            is2K: (element.video)?element.video.is2K: '',
            is4K: (element.video)?element.video.is4K: '',
            rules: (element.video)?element.video.rules: '',
            rulesFromCollection: (element.video)?element.video.rulesFromCollection: '',
            currentNumberOfQualities: (element.video)?element.video.currentNumberOfQualities: '',
          }
          this.rankingTable.push(object);
        });
        this.isGetTopInProgress = false;
        this.saveDisplayParameters();
        this.saveSortParameters();
      }).catch((error=>{
        console.log("Error while catching top videos")
        this.isGetTopInProgress = false;
        this.saveDisplayParameters();
        this.saveSortParameters();
      }))
    },
    forceUpdateTop() {
      this.updateTop();
    },
    activateTop(rankNbr)
    {
      let doUpdate = true;

      if (this.selectedDis === 'all')
        doUpdate = false;

      this.selectedDis = ""+rankNbr;
      this.rankSize = rankNbr;
      if (this.activeSort === "offload" || this.activeSort === "concurrentUsers" || this.activeSort === "rebuff" || this.activeSort === "dataDelivered" || this.activeSort === "totalMB_peer") {
        this.sortOn = this.activeSort;
      } else {
        this.activeSort = this.sortOn;     
      } 
      
      //if (doUpdate)
        this.updateTop();
    },

    mapSortTop()
    {
      let temp = "";
      if (this.activeSort === "offload")
      {
        this.sortOn = this.activeSort;
        temp="offload_percent";
      }
      else 
        if (this.activeSort === "concurrentUsers")
        {
          this.sortOn = this.activeSort;
          temp="max_viewers";
        }
        else 
          if (this.activeSort === "rebuff")
          {
            this.sortOn = this.activeSort;
            temp="rebuf";
          }
          else 
            if (this.activeSort === "dataDelivered")
            {
              this.sortOn = this.activeSort;
              temp="MB_total";
            }
            else 
              if (this.activeSort === "totalMB_peer")
              {
                this.sortOn = this.activeSort;
                temp="MB_peer";
              }

      return temp;
    },

    classicDate() {

      this.calendarValidate = false;

      let number = +this.dateLabel.substring(0, this.dateLabel.length - 1);
      let unit = this.dateLabel[this.dateLabel.length - 1];
      //this.range = {};
      let end = new Date();
      let start = null;

      if (unit === 'h') {
          start = new Date(end.getFullYear(), end.getMonth(), end.getDate(), end.getHours() - number, 0, 0);
          this.range = {
              start: start,
              end: end,
          }
      }
      else if (unit === 'd') {
          start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - number, end.getHours(), 0, 0);
          this.range = {
              start: start,
              end: end,
          }
      }
      this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm");
      this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm");
      this.updateTop();
    },

    adjustDate() {
      this.startDate = this.range.start;
      this.endDate = this.range.end;
      this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm");
      this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm");
    },
    displayBitrate(value) {
      let label = '';
      let unit = 'kbps';
      if (value > 1000) {
          unit = 'Mbps';
          value = Math.round(value / 1000 * 10) / 10
      }
      label += value + ' ' + unit;
      return label;
    },
    display_MB(value) {
      let label = [];
      let unit = 'kB';
      if (value > 1000000000000) {
        unit = 'PB';
        value = Math.round(value / 1000000000000 * 10) / 10
      } else if (value > 1000000000) {
        unit = 'TB';
        value = Math.round(value / 1000000000 * 10) / 10
      } else if (value > 1000000) {
        unit = 'GB';
        value = Math.round(value / 1000000 * 10) / 10
      } else if (value > 1000) {
        unit = 'MB';
        value = Math.round(value / 1000 * 10) / 10
      } else
        value = Math.round(value)

      return value + " "+ unit;
    },
    goToAnalytics(item)
    {
      this.$router.push('/analytics?video=' + item.videoID + '&title=videoconfig');
    },

    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    formatNbr(value)
    {
        if (value >= 1000 && (this.$ml.current === 'EN')) 
          value = new Intl.NumberFormat('en-EN').format(value); 
        else if (value > 1000 && (this.$ml.current === 'FR'))
          value = new Intl.NumberFormat('fr-FR').format(value);
        else if (value === 0.5) value = "< 1";

        return value;
    },

    /*
    updateRunningVids() {  
      this.interVidRun=0;      
      for (var i = 0; i < this.runningVideos.length; i++)
      {
        for (var j = 0; j < this.videos.length; j++)
        {
          if (this.runningVideos[i].videoID === this.videos[j].videoID) {
            this.interVidRun++;
          }
        }        
      }
      return this.interVidRun;
    },
    */

    getConfigs() {
      configurationService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
        this.configurations = configurations._embedded
        this.configurationsOptions = configurations._embedded.map(x => {return {text: x.name, value: x.key}});
        this.configurationsOptions.unshift({text: "All", value: ""});
      }).catch(err => {
        console.log(err);
      })
    },
    getRunningVideos() {
      analyticsService.getRunningVideos(this.clientView, this.$auth.token())
      .then(runningVideos => {
        this.runningVideos = runningVideos;
      }).catch(err => {
        console.log(err);
      })
    },

    getVideosRun(page) {

      let filter = this.searchParameters;
      this.applyAdvancedFilters();

      let params;
      let params2;
      this.isGetInProgress = true;

      this.videosRun = [];
      this.numberOfVideosRun = 0;
      
      if (this.selectedDis === 'all')
        this.defaultdate = moment(new Date(myDateBegin.getFullYear(),  myDateBegin.getMonth(), myDateBegin.getDate() -1, 0, 0, 0)).format("DD/MM/YY"),

      page = page || this.currentPageRun;

      params = {
        page: page,
        pagesize: this.numberPerPage,
        sort: this.mySort,
      };

      if (filter && filter !== "{}") {
        params.filter = filter;
      }
      if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
        var client = this.clientView;
        filter["client"] = client;
        params2 = {
          filter: {
            client: client
          }
        }
      }

      this.getNumberVideoPlatform();
      this.getNumberHidden();

      this.getRunningVideos();
      videoService
      .getVideoListPlugin(this.$auth.token(), params )
      .then((videos) => {
        this.videos = videos._embedded;

        this.numberOfVideos = videos._size;
        this.viewMenu = {};
        this.totalNumberOfPage = Math.ceil(
          this.numberOfVideos / this.numberPerPage
        );
        this.realTotalNumberOfPage = Math.ceil(
          this.numberOfVideos / this.numberPerPage
        );

        this.isGetInProgress = false;

        //Cet update précédemment commenté par Mathias mais pourquoi???
        this.updateSelectedNumber();

        for (let video in this.videos) 
        {
          let nameConfig="";
          this.videos[video]._modifyTags = false;
          this.videos[video]._created = moment(this.videos[video].createdDate).format("DD/MM/YY @HH:mm");
          if (this.configurations && this.configurations.find(x => x.key === this.videos[video].key) && (this.configurations.find(x => x.key === this.videos[video].key).name)) 
            nameConfig=this.configurations.find(x => x.key === this.videos[video].key).name;
          
          this.videos[video]._options = [
            {text: "[Config] "+nameConfig, value: "configuration"},
            {text: "Custom", value: "custom"},
          ];
          if (this.videos[video].p2pConf) {
            this.videos[video].p2pConf._latestDate = moment(this.videos[video].p2pConf.latestDate).format("DD/MM/YY @HH:mm");
            try {
              this.videos[video].p2pConf._timeElapsed = Math.round((new Date().getTime() - new Date(this.videos[video].p2pConf.latestDate).getTime()) /1000)
            } catch(err) {}
          }
          if (this.videos[video].collections && this.videos[video].collections.length > 0) {
            for(let i = 0; i < this.videos[video].collections.length; i++) {
              this.videos[video]._options.push({text:"[Collection] " + this.videos[video].collections[i], value: this.videos[video].collections[i]})
            }
          }
          if (this.videos[video].rulesFromCollection) {
            this.videos[video]._ruleSelected = this.videos[video].rulesFromCollection;
          } else if (!this.videos[video].rules || this.videos[video].rules.length === 0) {
            this.videos[video]._ruleSelected = "configuration"
          } else {
            this.videos[video]._ruleSelected = "custom"
          }
          this.videos[video]._initRuleSelected = this.videos[video]._ruleSelected;

        };
      }).catch((e) => {
        this.isGetInProgress = false;
        //this.updateSelectedNumber();
      });
    },

    
    getVideos(page) {

      let filter = this.searchParameters;
      this.applyAdvancedFilters();

      let params;
      let params2;
      this.isGetInProgress = true;
      this.videos = [];
      this.numberOfVideos = 0;
      page = page || this.currentPage;

      params = {
        page: page,
        pagesize: this.numberPerPage,
        sort: this.mySort,
      };

      if (filter && filter !== "{}") {
        params.filter = filter;
      }
      if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
        var client = this.clientView;
        filter["client"] = client;
        params2 = {
          filter: {
            client: client
          }
        }
      }

      this.getNumberVideoPlatform();
      this.getNumberHidden();

      this.getRunningVideos();
      videoService
      .getVideoListPlugin(this.$auth.token(), params )
      .then((videos) => {
        this.videos = videos._embedded;

        this.numberOfVideos = videos._size;
        this.viewMenu = {};
        this.totalNumberOfPage = Math.ceil(
          this.numberOfVideos / this.numberPerPage
        );
        this.realTotalNumberOfPage = Math.ceil(
          this.numberOfVideos / this.numberPerPage
        );

        this.isGetInProgress = false;

        //Cet update précédemment commenté par Mathias mais pourquoi???
        this.updateSelectedNumber();

        for (let video in this.videos) 
        {
          let nameConfig="";
          this.videos[video]._modifyTags = false;
          this.videos[video]._created = moment(this.videos[video].createdDate).format("DD/MM/YY @HH:mm");
          if (this.configurations && this.configurations.find(x => x.key === this.videos[video].key) && (this.configurations.find(x => x.key === this.videos[video].key).name)) 
            nameConfig=this.configurations.find(x => x.key === this.videos[video].key).name;
          
          this.videos[video]._options = [
            {text: "[Config] "+nameConfig, value: "configuration"},
            {text: "Custom", value: "custom"},
          ];
          if (this.videos[video].p2pConf) {
            this.videos[video].p2pConf._latestDate = moment(this.videos[video].p2pConf.latestDate).format("DD/MM/YY @HH:mm");
            try {
              this.videos[video].p2pConf._timeElapsed = Math.round((new Date().getTime() - new Date(this.videos[video].p2pConf.latestDate).getTime()) /1000)
            } catch(err) {}
          }
          if (this.videos[video].collections && this.videos[video].collections.length > 0) {
            for(let i = 0; i < this.videos[video].collections.length; i++) {
              this.videos[video]._options.push({text:"[Collection] " + this.videos[video].collections[i], value: this.videos[video].collections[i]})
            }
          }
          if (this.videos[video].rulesFromCollection) {
            this.videos[video]._ruleSelected = this.videos[video].rulesFromCollection;
          } else if (!this.videos[video].rules || this.videos[video].rules.length === 0) {
            this.videos[video]._ruleSelected = "configuration"
          } else {
            this.videos[video]._ruleSelected = "custom"
          }
          this.videos[video]._initRuleSelected = this.videos[video]._ruleSelected;

        };
      }).catch((e) => {
        this.isGetInProgress = false;
        //this.updateSelectedNumber();
      });
    },
    /*
    getClientCollections(){
      return new Promise((resolve, reject) => {
        videoService.getClientCollections(this.$auth.token(), this.clientView).then(res=>{
          res.forEach(tag=>{
            if (this.clientCollections.indexOf(tag._id) === -1) {
              this.clientCollections.push(tag._id)
            }
          })
          this.clientCollections.sort((a, b) => a.localeCompare(b));
          resolve()

        }).catch(err=>{
          console.error(`Error getting client's tags`, err)
          reject()
        })
      })
    },
    */
     getCollections(){
      return new Promise((resolve, reject) => {
        collectionService.getCollections({filter:{client:this.clientView},pagesize:1000}, this.$auth.token()).then(res=>{
          this.collections = res._embedded;
          this.clientCollections = [];
          res._embedded.forEach(collection=>{
            if (this.clientCollections.indexOf(collection.name) === -1) {
              this.clientCollections.push(collection.name);
            }
          })
          this.clientCollections.sort((a, b) => a.localeCompare(b));
          this.clientCollectionsComplete = this.clientCollections;
          resolve();
        }).catch(err=>{
          console.error(`Error getting client's tags`, err)
          reject();
        })
      })

    },
    getNumberVideoPlatform() {
      let myFilter = {};
      //this.applyAdvancedFilters(myFilter)
      videoService
      .getVideoListPlugin(this.$auth.token(), {
        pagesize: 0,
        filter: JSON.stringify({ client: this.clientView, ...myFilter}),
      })
      .then((videos) => {
        this.totalNumberOfVideos = videos._size;
      });
    },
    getNumberHidden() {
      let myFilter = {isHidden:true};
      videoService
      .getVideoListPlugin(this.$auth.token(), {
        pagesize: 0,
        filter: JSON.stringify({ client: this.clientView, ...myFilter}),
      })
      .then((videos) => {
        this.totalNumberVideoHidden = videos._size;
      });
    },
    applyAdvancedFilters(customSearchParameters) {
      let mySearchParameters = customSearchParameters || this.searchParameters;

      if(this.advancedFilters.length != 2)
      {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }
        if (this.advancedFilters.indexOf('live') === -1) {
          mySearchParameters["$and"].push({"stream_type":'vod'});
        }
        else if (this.advancedFilters.indexOf('vod') === -1) {
          mySearchParameters["$and"].push({"stream_type":'live'});
        }
      }

      if(this.protFilters.length != 2)
      {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }
        if (this.protFilters.indexOf('hls') === -1) {
          mySearchParameters["$and"].push({"protocol":'dash'});
        }
        else if (this.protFilters.indexOf('vod') === -1) {
          mySearchParameters["$and"].push({"protocol":'hls'});
        }
      }

      if(this.segFilters.length != 2)
      {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }
        if (this.segFilters.indexOf('ts') === -1) {
          mySearchParameters["$and"].push({"seg_ext":'mp4'});
        }
        else if (this.segFilters.indexOf('vod') === -1) {
          mySearchParameters["$and"].push({"seg_ext":'ts'});
        }
      }

      if(this.qualityFilters.length != 6)
      {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }

        if(this.qualityFilters.indexOf('isSD') === -1)
          mySearchParameters["$and"].push({"isSD":false});

        if(this.qualityFilters.indexOf('isHD') === -1)
          mySearchParameters["$and"].push({"isHD":false});

        if(this.qualityFilters.indexOf('isFullHD') === -1)
          mySearchParameters["$and"].push({"isFullHD":false});

        if(this.qualityFilters.indexOf('is2K') === -1)
          mySearchParameters["$and"].push({"is2K":false});

        if(this.qualityFilters.indexOf('is4K') === -1)
          mySearchParameters["$and"].push({"is4K":false});

        if(this.qualityFilters.indexOf('is8K') === -1)
          mySearchParameters["$and"].push({"is8K":false});
          
      }

      if(!this.seeHidden)
      {
        if (!mySearchParameters["$or"]) {
          mySearchParameters["$or"] = [];
        }
        if (mySearchParameters["$or"].findIndex(x => x.hasOwnProperty("isHidden")) === -1) {
          mySearchParameters["$or"].push({"isHidden":false});
          mySearchParameters["$or"].push({"isHidden":{"$exists": false}});
        }

      } else {
        if (!mySearchParameters["$or"]) {
          mySearchParameters["$or"] = [];
        }
        while (mySearchParameters["$or"].findIndex(x => x.hasOwnProperty("isHidden")) !== -1) {
          mySearchParameters["$or"].splice(mySearchParameters["$or"].findIndex(x => x.hasOwnProperty("isHidden")), 1)
        }
        if (mySearchParameters["$or"].length === 0) {
          delete mySearchParameters["$or"];
        }
      }

      try {
        if(mySearchParameters["$and"].length === 0) {
          delete mySearchParameters["$and"];
        }
      } catch(err) {}
      //console.log('[Advanced filters]', this.isImbricated, mySearchParameters["$and"])
       
    },

    resetAll() {
      this.seeHidden = false;
      this.isRunningOnly = false;
      this.search = "";
      this.searchCollection = "";
      this.selectedCollections = [];
      this.selectedCollection = "";
      this.exludedCollections = [];
      this.selectedKey = "";
      this.advancedFilters = ['live', 'vod'];
      this.protFilters = ['hls','dash'];
      this.segFilters = ['ts','mp4'];
      this.qualityFilters = ['isSD','isHD','isFullHD','is2K','is4K','is8K'];
      this.startTimeoutSearch();
    },

    resetTypesF() {
      this.seeHidden = false;
      this.isRunningOnly = false;
      this.selectedKey = "";
      this.advancedFilters = ['live', 'vod'];
      this.protFilters = ['hls','dash'];
      this.segFilters = ['ts','mp4'];
      this.qualityFilters = ['isSD','isHD','isFullHD','is2K','is4K','is8K'];
      this.startTimeoutSearch();
    },

    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {console.log(e)}
      //if (this.oldSearch !== this.search || this.advancedFilters.join('') !== this.oldAdvancedFilters || this.qualityFilters.join('') !== this.oldQualityFilters) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(this.onSearchBar, this.timeoutSearchDuration * 1000);
      /*} else {
        this.isGetInProgress = false;
      }*/
    },

    refreshManual() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {console.log(e)}
      this.isGetInProgress = true;
      this.timeoutSearch = setTimeout(this.onSearchBar, this.timeoutSearchDuration * 1000);
    },
    onSearchBar() {
      //this.selectedDis = 'all';
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      let words = this.search.toLowerCase().split(" ");
      this.oldSearch = this.search;
      this.oldAdvancedFilters = this.advancedFilters.join("");
      this.oldQualityFilters = this.qualityFilters.join("");
      this.searchParameters = {};
      if ( this.search !== "") {
        this.searchParameters["$and"] = [];

        for (let word of words) 
        {
          if (word.startsWith("uuid:") || word.startsWith("id:")) 
          {
            let uuid = word.split(":")[1].split("+");
            if (uuid.length > 1) {
              this.searchParameters["$and"].push({ videoID: { $in: uuid } });
            } else {
              this.searchParameters["$and"].push({ videoID: word.split(":")[1] });
            }
          } else if (word.startsWith("key:")) {
            let key = word.split(":")[1].split("+");
            if (key.length > 1) {
              this.searchParameters["$and"].push({ key: { $in: key } });
            } else {
              this.searchParameters["$and"].push({ key: word.split(":")[1] });
            }
          } else if (word.startsWith("config:")) {
            let config = word.split(":")[1].split("+");
            if (config.length > 1) {
              let configsFiltered = this.configurations.filter(x => config.indexOf(x.name) > -1);
              if (configsFiltered.length > 0) {
                let configsMapped = configsFiltered.map(x => x.key)
                this.searchParameters["$and"].push({ key: { $in: configsMapped } });
              }
            } else {
              try {
                let configurationKey = this.configurations.find(x => x.name === word.split(":")[1])
                if (configurationKey) {
                  this.searchParameters["$and"].push({ key: configurationKey.key});
                } else {
                  this.searchParameters["$and"].push({ key: word.split(":")[1]});
                }
              } catch(err) {}
            }
          } else if (word.startsWith("description:")) {
            let decription = word.split(":")[1].split("+");
            decription = decription.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (decription.length > 1) {
              this.searchParameters["$and"].push({
                description: { $regex: decription.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                description: { $regex: decription[0] },
              });
            }
          } else if (word.startsWith("title:")) 
            {
            let title = word.split(":")[1].split("+");
            title = title.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (title.length > 1) {
              this.searchParameters["$and"].push({
                videoID: { $regex: title.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                videoID: { $regex: title[0] },
              });
            }

          } /*else if (word.startsWith("tags:")) 
            {
            let tags = word.split(":")[1].split("+");
            tags = tags.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (tags.length > 1) {
              this.searchParameters["$and"].push({
                tags: { $regex: tags.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                tags: { $regex: tags[0] },
              });
            }

          }*/ else {
            var objTest = { $regex: "(?i)^.*" + word + ".*" };
            this.searchParameters["$and"].push({
              $or: [{ videoID: objTest }/*, { tags: objTest }*/],
            });
          }
        }
      }

      if (this.selectedCollections.length>0 || this.exludedCollections.length>0)
      {
        if(this.selectedCollections.length>0)
        {
          this.searchParameters["$and"] = this.searchParameters["$and"] || [];
          this.searchParameters["$and"].push({
            collections:{$in:this.selectedCollections}
          })
        }
        if(this.exludedCollections.length>0)
        {
          this.searchParameters["$and"] = this.searchParameters["$and"] || [];
          this.searchParameters["$and"].push({
            collections:{$nin:this.exludedCollections}
          })
        }      
      }
      if (this.selectedKey !== "") {
        this.searchParameters["$and"] = this.searchParameters["$and"] || [];
        this.searchParameters["$and"].push({
          key: this.selectedKey
        })
      }

      //console.log("SEARCH PARAMETERS",this.searchParameters);

      let previousSearchParameters = this.getSearchParameters();
      this.saveSearchParameters();
      this.saveSeeHidden();
      this.currentPage = 1;
      this.getVideos();
    },

    getDisplayParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.selectedDisplay = searchStorage.getItem("QuanteecLabs_selectedDisplay");
        result.selectedDis = searchStorage.getItem("QuanteecLabs_selectedDis");
        result.sortOn = searchStorage.getItem("QuanteecLabs_sortOn");
        result.dateLabel = searchStorage.getItem("QuanteecLabs_dateLabel");
        result.range = JSON.parse(searchStorage.getItem("QuanteecLabs_range"));
      } catch (err) {
        console.log(err);
      }
      return result;
    },
    saveDisplayParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_selectedDisplay", this.selectedDisplay);
        searchStorage.setItem("QuanteecLabs_selectedDis", this.selectedDis);
        searchStorage.setItem("QuanteecLabs_sortOn", this.sortOn);
        searchStorage.setItem("QuanteecLabs_dateLabel", this.dateLabel);
        searchStorage.setItem("QuanteecLabs_range", JSON.stringify(this.range));
      } catch (err) {}
    },

    getShowActive() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.isRunningOnly = searchStorage.getItem("QuanteecLabs_showActive");
      } catch (err) {
        console.log(err);
      }
      return result;
    },
    saveShowActive() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_showActive", this.isRunningOnly);

      } catch (err) {}
    },

    getShowCol() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.showFilterC = searchStorage.getItem("QuanteecLabs_showFilterC");
      } catch (err) {
        console.log(err);
      }
      return result;
    },
    saveShowCol() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_showFilterC", this.showFilterC);

      } catch (err) {}
    },

    getShowFil() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.showFilterT = searchStorage.getItem("QuanteecLabs_showFilterT");
      } catch (err) {
        console.log(err);
      }
      return result;
    },
    saveShowFil() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_showFilterT", this.showFilterT);

      } catch (err) {}
    },

    getSeeHidden() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.seeHidden = searchStorage.getItem("QuanteecLabs_seeHidden");
      } catch (err) {
        console.log(err);
      }
      return result;
    },
    saveSeeHidden() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_seeHidden", this.seeHidden);

      } catch (err) {}
    },

    getShowDetailsRow() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.showDetailsRow = searchStorage.getItem("QuanteecLabs_showDetailsRow");
      } catch (err) {
        console.log(err);
      }
      return result;
    },
    saveShowDetailsRow() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_showDetailsRow", this.showDetailsRow);

      } catch (err) {}
    },


    getSearchParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.searchParametersString = searchStorage.getItem(
          "QuanteecLabs_searchparameters"
        );
        result.searchParameters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_searchparameters")
        );
        result.searchBar = searchStorage.getItem("QuanteecLabs_searchbar");
        result.searchKey = searchStorage.getItem("QuanteecLabs_searchkey") || "";
        result.qualityFilters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_qualityFilters")
        );
        result.advancedFilters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_advancedFilters")
        );
        result.protFilters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_protFilters")
        );
        result.segFilters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_segFilters")
        );
        
      } catch (err) {
        console.log(err);
      }

      return result;
    },
    saveSearchParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem(
          "QuanteecLabs_searchparameters",
          JSON.stringify(this.searchParameters)
        );
         searchStorage.setItem(
          "QuanteecLabs_searchkey",
          this.selectedKey
        );
        searchStorage.setItem("QuanteecLabs_searchbar", this.search);
        searchStorage.setItem("QuanteecLabs_qualityFilters", JSON.stringify(this.qualityFilters));
        searchStorage.setItem("QuanteecLabs_advancedFilters", JSON.stringify(this.advancedFilters));
        searchStorage.setItem("QuanteecLabs_protFilters", JSON.stringify(this.protFilters));
        searchStorage.setItem("QuanteecLabs_segFilters", JSON.stringify(this.segFilters));

      } catch (err) {}
    },
    changeCollectionState(collection)
    {
      var selectedIndex = this.selectedCollections.indexOf(collection);
      var excludedIndex = this.exludedCollections.indexOf(collection)
      
      //TO-DO récupérer l'icone du collection et le changer 

      if((selectedIndex === -1 && excludedIndex === -1))
      {
          this.selectedCollections.push(collection)
          this.startTimeoutSearch();
      } else if (selectedIndex != -1 && excludedIndex === -1) {
          this.selectedCollections.splice(selectedIndex,1)
          this.exludedCollections.push(collection)
          this.startTimeoutSearch();
      } else {
          this.exludedCollections.splice(excludedIndex, 1)
          this.startTimeoutSearch();
      }
      this.clientCollections = this.clientCollections.splice(0)
    },
    selectCollection(collection) {
      var selectedIndex = this.selectedCollections.indexOf(collection);
      if((selectedIndex === -1 ))
      {
          this.selectedCollections.push(collection)
          this.startTimeoutSearch();
      } else if (selectedIndex != -1) {
          this.selectedCollections.splice(selectedIndex,1)
          this.startTimeoutSearch();
      }
      this.clientCollections = this.clientCollections.splice(0)
    },
    updateVideoPluginList()
    {
        this.isGetInProgress = true;
        let params;
        if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
          let client = this.clientView;
          params = {
            filter: {
              client: client
            }
          };

        }
        videoService.refreshVideoPlugin(this.$auth.token(), params)
        .then(()=>{
            this.getCollections().catch(err => {});
            this.getVideos(this.currentPage)
        })
        .catch(err=>{
          this.isGetInProgress = false;
            console.log(err)
        })
    },
    startModifyTags(video)
    {
      if (video.tags && video.tags !== '' && video.Tags !== '|:|') {
        video._tags = video.tags.split('|:|').map( x => {return {key: "", value: x}});
      } else {
        video._tags = [];
      }
      video._modifyTags = true;
      this.videos = this.videos.splice(0);
    },
    endModifyTags(video) {
      video.tags = video._tags.map(x => x.value).join('|:|');
      video._modifyTags = false;
      this.videos = this.videos.slice(0);
    },
    cancelModifyTags(video)
    {
      var tags = video.tags
      videoService.putVideoPluginById({tags: tags}, video._id, this.$auth.token()).then(() => {
          videos = videos.splice(0);
      }).catch((err) => {

      })
    },
    removeCollectionFromVideo(video, collection) {
      let videoCollections = video.collections || [];
      let idxCollection = videoCollections.findIndex(x => x === collection)
      if (idxCollection > -1) {
        videoCollections.splice(idxCollection, 1);
        let dataToUpdate = {collections: videoCollections, "$addToSet":{blacklistCollections: collection}};
        if (video.rulesFromCollection && video.rulesFromCollection === collection) {
          dataToUpdate.rulesFromCollection = "";
        }
        videoService.putVideoPluginById(dataToUpdate, video._id, this.$auth.token()).then(() => {
          this.getVideos();
        }).catch((err) => {
          alert(this.$ml.get("errorlinkcollection"))
          this.getVideos();
        })
    
      }
    },
    updateTags(video) {
        var tags = video._tags.map(elem => elem.value).join('|:|');
        videoService.putVideoPluginById({tags: tags}, video._id, this.$auth.token()).then(() => {
          videos = videos.splice(0);
        }).catch((err) => {

        })
    },
    updateDescription(video) {
        videoService.putVideoPluginById({description: video._desc}, video._id, this.$auth.token()).then(() => {
          video._modifyDescription = false;
          video.description = video._desc;
          this.videos = this.videos.splice(0);
        }).catch((err) => {

        })
    },
    cancelDescription(video){
      video._modifyDescription = false;
      this.videos = this.videos.splice(0);
    },

    inputParametersSelected(video) {
      //console.log(video._ruleSelected);
      this.updateRuleSelected(video);
      this.videos = this.videos.splice(0);
    },
    updateRuleSelected(video) {
      if (video._ruleSelected === "configuration") {
        videoService.putVideoPluginById({rulesFromCollection: "", rules: null}, video._id, this.$auth.token())
          .then(() => {
            video._initRuleSelected = "configuration";
            this.getVideos();
          })
          .catch(err => {
            alert("Error updating the parameters. Please retry later.")
          })
      } else if (video._ruleSelected === "custom") {
        this.selectedVideo = video;
        this.showModal("authorizations");
        this.getVideos();
      } else {
        videoService.putVideoPluginById({rulesFromCollection: video._ruleSelected}, video._id, this.$auth.token())
          .then(() => {
            video._initRuleSelected = video._ruleSelected;
            this.getVideos();
          })
          .catch(err => {
            alert("Error updating the parameters. Please retry later.")
          })
      }
    },
    openModalThumbnail()
    {
      this.selectedVideo._thumbnailURL = this.selectedVideo.thumbnailURL; 
    },
    changeActiveSort(value, defaultOrder) {
      var sortObject = {};
      /*
      if (value !== this.activeSort) {
        this.activeSortOrder = (defaultOrder !== undefined) ? defaultOrder : 1;
        this.activeSort = value;
      } else {
        this.activeSortOrder = this.activeSortOrder === 1 ? -1 : 1;
      }
      */
      if (defaultOrder !== undefined)
        this.activeSortOrder = this.activeSortOrder === 1 ? -1 : 1;
        
      this.saveSortParameters();
      sortObject[this.activeSort] = this.activeSortOrder;
      this.mySort = JSON.stringify(sortObject);
      this.getVideos(this.currentPage);
    },
    saveSortParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_sortparam", this.activeSort);

        searchStorage.setItem(
          "QuanteecLabs_sortorder",
          this.activeSortOrder === 1 ? "asc" : "desc"
        );
      } catch (err) {}
    },
    getSortParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.sort = searchStorage.getItem("QuanteecLabs_sortparam");

        result.sortOrder = searchStorage.getItem("QuanteecLabs_sortorder");
        if (result.sortOrder === "asc") {
          result.sortOrder = 1;
        } else {
          result.sortOrder = -1;
        }
      } catch (err) {}

      return result;
    },
    getListAllVideos()
    {
      return this.videos;
    },
    checkAllSelected() {
      let allVideos = this.getListAllVideos();
      let oneNotSelected = allVideos.findIndex(x => !x._isSelected);
      if (oneNotSelected > -1) {
        this.isSelectAll = false;
      } else {
        this.isSelectAll = true;
      }
    },

    updateSelectedNumber() {
      let allVideos = this.getListAllVideos();
      this.nbrVideoSelected = allVideos.filter(x => x._isSelected).length;
      this.checkAllSelected();
    },
    openAnalyticsForVideo(video) {
      if (this.configurations && this.configurations.length > 0 && this.configurations.find(x => x.key === video.key)) {
        this.$router.push('/analytics?key='+ video.key +'&config='+ this.configurations.find(x => x.key === video.key).name+'&video=' + video.videoID + '&title=videoconfig');
      } else {
        this.$router.push('/analytics?key='+ video.key +'&video=' + video.videoID + '&title=videoconfig');
      }
    },
    updateHideVideo(){
      let allVideos = this.getListAllVideos();
      let arrayPromise = []
      for (var video of allVideos) {
        if (video._isSelected) {
         video.isHidden = true;
         arrayPromise.push(this.updateHidden(video));
        }
      }
      Promise.all(arrayPromise).then(()=>{
        this.nbrVideoSelected = 0;
        this.refreshManual()
      }).catch(err=>{
        console.log(err)
      })
    },

    updateUnhideVideo(){
      let allVideos = this.getListAllVideos();
      let arrayPromise = []
      for (var video of allVideos) {
        if (video._isSelected) {
         video.isHidden = false;
         arrayPromise.push(this.updateHidden(video));
        }
      }
      Promise.all(arrayPromise).then(()=>{
        this.nbrVideoSelected = 0;
        this.refreshManual()
      }).catch(err=>{
        console.log(err)
      })
    },    

    updateHidden(video) {
      return new Promise((resolve, reject) => {
        videoService.putVideoPluginById({isHidden: video.isHidden}, video._id, this.$auth.token()).then(() => {
            video._isSelected = false;
            resolve();
          }).catch((err) => {
            reject(err);
        })
      })

    },
    removeCollection(collection) {
      collectionService.deleteCollection(collection.uuid, this.$auth.token())
      .then(() => {
        this.getCollections();
        this.getVideos();
      }).catch(err => {
        alert();
      })
    },
    removeMultipleCollection(collectionsSelected)
    {
      const reflect = p => p.then(v => ({v, status: "fulfilled" }),
                            e => ({e, status: "rejected" }));

      let promisesCollection = []

      collectionsSelected.forEach(collectionName =>{
        let collection = this.collections.find(x=>x.name === collectionName)
        promisesCollection.push[reflect(collectionService.deleteCollection(collection.uuid, this.$auth.token()))]
      })

      Promise.all(promisesCollection).then(()=>{
        this.getCollections();
        this.getVideos();
        this.selectedCollections = []
      })

    },
    onCloseModal(success, modalID) {
      if (success) {
        this.getCollections();
        this.getVideos();
        this.hideModal(modalID)
      }
    },
    startFilterCollection()
    {
      this.clientCollections = this.clientCollectionsComplete.filter(collection => collection.toLowerCase().includes(this.searchCollection.toLowerCase()));
    }, 
    searchConfig(configurations, item)
    {
      var config = configurations.find(x => x.key === item.key)
      var configName = "";
      if(config != null){
        configName = config.name
      }
      
      return configName
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.previewContainer {
  position: relative;
  width: 100%;
//  padding-top: 56.25%;
  padding-top: 7%;
  padding-bottom: 7%;
  background-color: black;
}

.previewImg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.scrollmenu {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  white-space: nowrap;
}

.defaultAuthBadge {
  cursor: pointer;
  font-size: 0.8rem;
  padding: 8px;
  border-radius: 10px;
  background-color: rgba(#2F90B0, 0.2);
  transition: .15s all ease-in-out;
  border: 1px solid grey;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    border: 1px solid grey;
    color: #2F90B0;
    background-color: white;
  }
}
.configBadge {
  cursor: pointer;
  font-size: 0.8rem;
  padding: 8px;
  border-radius: 10px;
  background-color: rgba(#7b7b00, 0.2);
  transition: .15s all ease-in-out;
  border: 1px solid grey;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    border: 1px solid grey;
    color: #7b7b00;
    background-color: white;
  }
}

.collectionParamBadge {
  cursor: pointer;
  font-size: 0.8rem;
  padding: 8px;
  border-radius: 10px;
  background-color: rgba(#14BF98, 0.2);
  transition: .15s all ease-in-out;
  border: 1px solid grey;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    border: 1px solid grey;
    color: #14BF98;
    background-color: white;
  }
}

.customParamBadge {
  cursor: pointer;
  font-size: 0.8rem;
  padding: 8px;
  border-radius: 10px;
  background-color: rgba(#2a5d77, 0.2);
  transition: .15s all ease-in-out;
  border: 1px solid grey;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    border: 1px solid grey;
    color: #2a5d77;
    background-color: white;
  }
}

.linkBadge {
  cursor: pointer;
  background-color: rgba(#11a280, 0.9);
  border: 1px solid grey;
  padding: 3px 10px;
}

.hiddenAuthBadgeNone {
  display: inline-block;
  color: transparent;
  text-align: center;
  font-size: 0.7rem;
  padding: 2px 10px;
  border-radius: 5px;
  border: 1px solid transparent;
  background-color: transparent;
  margin: 0px;
  cursor: default;
}

.hiddenAuthBadgeWO {
  display: inline-block;
  color: black;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  border-radius: 5px;
  border: solid 1px rgba(#af4d20, 0.2);
  background-color: rgba(#ef8655, 0.2);
  margin: 2px 1px;
}

.hiddenAuthBadgeDisWO {
  display: inline-block;
  color: black;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  border-radius: 5px;
  border: solid 1px rgba(#af4d20, 0.2);
  background-color: rgba(#af4d20, 0.2);
  margin: 2px 1px;
}


.hiddenAuthBadge {
  display: inline-block;
  color: black;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  border-radius: 5px;
  border: solid 1px rgba(#af4d20, 0.2);
  background-color: rgba(#ef8655, 0.2);
  margin: 2px 1px;
  width: 160px !important;
  &:hover {
    color: black;
    background-color: rgba(#af4d20, 0.2);
    cursor:pointer;

  }  
}

.hiddenAuthBadgeDis {
  display: inline-block;
  color: black;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  border-radius: 5px;
  border: solid 1px rgba(#af4d20, 0.2);
  background-color: rgba(#af4d20, 0.2);
  margin: 2px 1px;
  cursor:pointer;
  width: 160px !important;
  &:hover {
    color: black;
    background-color: rgba(#ef8655, 0.2);
  }  
}

.runningVidsBadgeWO {
  display: inline-block;
  color: black;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  border: solid 1px #ba0000; 
  border-radius: 5px;
  background-color: rgba(#ba0000, 0.2);
  margin: 2px 1px;
}

.runningVidsBadgeDisWO {
  display: inline-block;
  text-align: center;
  color: black;
  font-size: 0.7rem;
  padding: 5px;
  border-radius: 5px;
  border: solid 1px #ba0000;
  background-color: rgba(white, 0.2);
  margin: 2px 1px;
}


.runningVidsBadge {
  display: inline-block;
  color: black;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  border: solid 1px #ba0000; 
  border-radius: 5px;
  cursor:pointer;
  background-color: rgba(#ba0000, 0.2);
  margin: 2px 1px;
  width: 160px;
  &:hover {
    color: #ba0000;
    background-color: rgba(white, 0.2);
  }
}

.runningVidsBadgeDis {
  display: inline-block;
  text-align: center;
  color: black;
  font-size: 0.7rem;
  padding: 5px;
  border-radius: 5px;
  border: solid 1px #ba0000;
  background-color: rgba(white, 0.2);
  margin: 2px 1px;
  cursor:pointer;
  width: 160px;
  &:hover {
    background-color: rgba(#ba0000, 0.2);
  }
}

.noneBadge {
  display: inline-block;
  text-align: center;
  padding: 5px;
  border: solid 1px grey; 
  font-size: 0.7rem;
  border-radius: 5px;
  margin: 2px 1px;
}
.transBadge {
  display: inline-block;
  text-align: center;
  padding: 5px;
  border: solid 1px transparent; 
  background-color: transparent;
  font-size: 0.7rem;
  border-radius: 5px;
  margin: 2px 1px;
}
.hiddenBadgeNbr {
  display: inline-block;
  cursor: pointer; 
  padding: 5px;
  margin: 2px 1px;
  color: black;
  border: solid 1px rgba(#af4d20, 0.2); 
  background-color: rgba(#af4d20, 0.2);
  min-width: 20px;
  &:hover {
    color: black;
    background-color: rgba(#ef8655, 0.2);
  }  
}

.hiddenBadgeNbrDis {
  display: inline-block;
  cursor: pointer;
  padding: 5px;
  margin: 2px 1px;
  color: black;
  border: solid 1px rgba(#af4d20, 0.2); 
  background-color: rgba(#ef8655, 0.2);
  min-width: 20px;
  &:hover {
    color: black;
    background-color: rgba(#af4d20, 0.2);
  }
}

.runningBadgeNbr {
  display: inline-block;
  cursor: pointer;
  padding: 5px; 
  margin: 2px 1px;
  color: black;
  border: solid 1px #ba0000; 
  background-color: rgba(#ba0000, 0.2);
  min-width: 20px;
  &:hover {
    color: #ba0000;
    background-color: rgba(white, 0.2);
  }
}

.runningBadgeNbrDis {
  display: inline-block;
  cursor: pointer;
  padding: 5px;
  margin: 2px 1px;
  color: black;
  border: solid 1px #ba0000;
  background-color: rgba(white, 0.2);
  min-width: 20px;
  &:hover {
    background-color: rgba(#ba0000, 0.2);
  }
}

.collectBadgeSel {
  display: inline-block;
  background-color: #14BF98;
  color: white;
  text-align: center;
  padding: 5px;
  border: solid 1px #14BF98;
  font-size: 0.7rem;
  border-radius: 5px;
  margin: 2px 1px;
  min-width: 50px;
}
.collectBadgeExl {
  display: inline-block;
  text-align: center;
  font-size: 0.7rem;
  padding: 5px;
  color: white;
  border-radius: 5px;
  border: solid 1px #ba0000;
  background-color: #ba0000;
  margin: 2px 1px;
  min-width: 50px;
}
.badgenoneshow {
  display: inline-block;
  margin-left: 0.5rem;
  color: white;
  border: 1px solid #2a5d77;  
  background-color: #2a5d77;
  cursor: pointer;
  width: 20px;
  &:hover {
    color: #14BF98 !important;
    background-color: white !important;
  }
}
.badgenonehide {
  display: inline-block;
  margin-left: 0.5rem;
  color: #14BF98;
  border: 1px solid #14BF98;
  background-color: white;
  cursor: pointer;
  width: 20px;
  &:hover {
    color: white !important;
    background-color: #2a5d77 !important;
  }
}
.badgeReset {
  margin-left: 0.5rem;
  color: white;
  border: 1px solid #f98e35;
  background-color: #f98e35;
  padding-left: 0px;
  padding-right: 0px;
  cursor: pointer;
  width: 20px;
  &:hover {
    color: #f98e35 !important;
    background-color: white !important;
  }
}

.badge{
  font-weight: 500;
}
.tag-config {
  cursor: pointer;
  border: 1px solid rgb(123, 123, 0) !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin-right: 2px;
  padding: 1px 10px;
  background-color: white;
  color: rgb(123, 123, 0);
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
}

.tag-not-selected {
  display: inline-block; 
  cursor: pointer;
  border: 1px solid #2a5d77 !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin-right: 3px;
  padding: 3px;
  padding-left: 10px; 
  padding-right: 10px;
  background-color: #2a5d77;
  color: white;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    color: #2a5d77 !important;
    background-color: white !important;
  }
  
}

.tag-selected {
  display: inline-block; 
  cursor: pointer;
  border: 1px solid #14BF98 !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  text-align: center;
  margin-right: 3px;
  padding: 3px;
  padding-left: 10px; 
  padding-right: 10px;
  background-color: #14BF98;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  color: white;
  &:hover {
    color: #14BF98 !important;
    background-color: white !important;
  }
}

.tag-excluded {
  display: inline-block; 
  cursor: pointer;
  border: 1px solid rgb(189, 6, 6) !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  text-align: center;
  margin-right: 3px;
  padding: 3px;
  padding-left: 10px; 
  padding-right: 10px;
  background-color: rgb(189, 6, 6);
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  color: white;
  &:hover {
    color: rgb(189, 6, 6) !important;
    background-color: white !important;
  }
}

.noDisplay {
  display: none;
}

.collection-linked {
  border: 1px dashed #14BF98;
  border-radius: 2px;
  padding: 2px;
  text-align: center;
  padding-bottom: 0px;
  margin-bottom: 2px;
}

.config-linked {
  border: 1px dashed rgb(123, 123, 0);
  border-radius: 2px;
  padding: 3px;
  text-align: center;
  background-color: transparent;
}

.iconStyle {
  cursor: pointer;
  color: white;
  padding: 2px;
  margin-right: 3px;
  background-color: #113448;
  border: 1px solid #113448;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    color: #113448;
    background-color: white;
  }
}

.iconStyleC {
  color: white;
  padding: 2px;
  margin-right: 1px;
  background-color: #2a5d77;
  border: 1px solid #2a5d77;
}

.iconStyleCol {
  color: white;
  padding: 2px;
  margin-right: 3px;
  background-color: #14BF98;
  border: 1px solid #14BF98;
}

.iconStyleDef {
  color: white;
  padding: 2px;
  margin-right: 3px;
  background-color: #2F90B0;
  border: 1px solid #2F90B0;
}

.iconStyleConf {
  color: white;
  padding: 2px;
  margin-right: 3px;
  background-color: #7b7b00;
  border: 1px solid #7b7b00;
}

.iconStyleR {
  cursor: pointer;
  color: white;
  padding: 1px;
  margin-right: 3px;
  background-color: #ba0000;
  border: 1px solid #ba0000;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    color: #ba0000;
    background-color: white;
  }
}

.panelCT {
  border-bottom:solid 1px #ced4da; 
  padding:1rem;
}

.green {
  color: #14BF98;
}
.greenP {
  color: #14BF98;
  cursor:pointer;
  &:hover {
    color: #048F94;
  }
}
.red {
  color: rgb(189, 6, 6);
}
.orange {
  color: orange;
}
.black {
  color: black;
}
.blueV {
  color: #2F90B0;
}
.blueQ {
  color: #38abd1;
}
.blueC {
  color: #42c8f5;
}
.blue {
  color: #007BFF;
}
.gray {
  color: #aac8d4;
}
.hidden {
  color: #af4d20;
}
.darkblue {
  color: #2a5d77;
  cursor:pointer;
  &:hover {
    color: #048F94;
  }
}

.circleCT {
  padding-bottom: 0.25rem;
  margin-left: 0.25rem;
}

.separatorCard {
  margin-left: 1rem;
  margin-right: 1rem;
  border-top: 1px solid #2F90B0;
}

.separatorCardDashed {
  margin-left: 1rem;
  margin-right: 1rem;
  border-top: 1px dashed #2F90B0;
}

.separatorCardBottom {
  margin-left: 2rem;
  margin-right: 2rem;
  border-top: 1px dashed #2F90B0;
}

.toolong {
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
}

.pointerC {
  cursor: pointer;
}

.selectCol {
  font-weight: bold ;
}

@media (max-width: 1200px) {
  .justifCC {
    justify-content: space-around ;  
  }
}

@media (max-width: 576px) {
  .paddingRL {
    padding:0px;
  }
  .marginNbrVids {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}

@media (min-width: 576px) {
  .borderR {
    border-right: 1px solid #ced4da;
  }
  .borderRL {
    border-right: 1px solid #2a5d77;
    border-left: 1px solid #2a5d77;
    border-radius:5px;
  } 
  .borderT {
    border-top: 1px solid #2a5d77;
  }

  .marginB {
    margin: 0px -15px !important;
  }

  .borderVidsDis {
    border-top: 0px solid #ced4da;
    border-bottom: none;
    border-right: 1px solid #ced4da;
    border-left: 1px solid #ced4da;
    margin-top: 0;
    margin-bottom: 0;
  }

}

.backDisD {
  color: #fff  !important;
  text-align: center;
  cursor: pointer;
  background-color: #113448  !important;
  border: 0.1rem solid  #2a5d77 !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
  box-shadow: rgba(#2a5d77, 0.17) 1px 2px 4px, rgba(#2a5d77, 0.17) 1px 2px 4px;
  &:hover {
    color: #048F94 !important;
    border: 0.1rem solid #048F94 !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}

.backDisG {
  color: #048F94  !important;
  text-align: center;
  background-color: #fff  !important;
  border: 1px solid #2a5d77 !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
  box-shadow: rgba(#2a5d77, 0.17) 1px 2px 4px, rgba(#2a5d77, 0.17) 1px 2px 4px;
}

.badgeFilterSel {
  background-color: #14BF98;
  margin:2px 2px 10px 3px;
  font-size: x-small;
  padding:3px;
}

.timeSel {
  display: inline;
  font-size: 13px;
  max-width: 180px;
  margin-left: 5px;
  text-align: center;
  &:hover {
    color: #048F94 !important;
    border: 0.1rem solid #048F94 !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
    cursor: pointer;
  }
}

.timeSelDis {
  display: inline;
  font-size: 13px;
  max-width: 180px;
  margin-left: 5px;
  text-align: center;
}

.greenwSel {
  display: inline;
  text-align: center;
  margin-left: 5px;
  font-size: 13px;
  max-width: 137px;
  color: #14BF98 !important;
  background-color: #fff  !important;
  border: 0.1rem solid #2a5d77 !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: #048F94 !important;
    border: 0.1rem solid #048F94 !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
    cursor: pointer;
  }
 }

.row {
  margin-left:0;
  margin-right:0;
}

.small {
  font-size: small !important;
}

.activeClass {
//  background-color: rgb(219, 214, 214);
  //color: rgb(219, 214, 214);
  opacity: 0.23;
}

</style>
